/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./components/Button.ts":
/*!******************************!*\
  !*** ./components/Button.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Button: () => (/* binding */ Button)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class Button extends HTMLElement {
  constructor() {
    var _this;
    super();
    _this = this;
    /**
     *
     * @param value
     */
    _defineProperty(this, "setLoading", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      _this.setDisable(value);
      if (value) {
        var loaderEl = _this.querySelector('[data-loader]');
        if (!loaderEl) _this.insertAdjacentHTML('afterbegin', "<span data-loader class=\"es-loader es-absolute es-bottom-1/2 es-left-1/2\" style=\"transform: translateX(-50%)\"></span>");
      } else {
        _this.querySelectorAll('[data-loader]').forEach(i => i.remove());
      }
    });
    /**
     *
     * @param value
     */
    _defineProperty(this, "setDisable", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var classes = ['es-opacity-60', '!es-cursor-not-allowed', 'es-pointer-events-none'];
      value ? _this.classList.add(...classes) : _this.classList.remove(...classes);
    });
    /**
     *
     * @param value
     * @param position
     */
    _defineProperty(this, "setLabel", function (value) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'beforeend';
      if (!_this.labelEl) {
        _this.insertAdjacentHTML(position, "<span data-label class=\"es-text-nowrap\">".concat(value !== null && value !== void 0 ? value : '', "</span>"));
        _this.labelEl = _this.querySelector('[data-label]');
      } else {
        _this.labelEl.innerHTML = value !== null && value !== void 0 ? value : '';
      }
    });
    /**
     *
     * @param value
     * @param position
     */
    _defineProperty(this, "setIcon", function (value) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterbegin';
      if (!_this.iconEl) {
        _this.insertAdjacentHTML(position, "<span data-icon>".concat(value, "</span>"));
        _this.iconEl = _this.querySelector('[data-icon]');
      } else {
        _this.iconEl.innerHTML = value;
      }
    });
    this.classList.add(...[_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, _classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, _classes__WEBPACK_IMPORTED_MODULE_0__.classes.itemsCenter, _classes__WEBPACK_IMPORTED_MODULE_0__.classes.cursorPointer, _classes__WEBPACK_IMPORTED_MODULE_0__.classes.relative]);
    this.role = 'button';
    if (this.hasAttribute('data-label')) this.setLabel(this.getAttribute('data-label'));
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-label', 'data-disabled'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-label' && newValue) this.setLabel(newValue);
    if (name === 'data-disabled' && newValue) this.setDisable(!(newValue === 'false' || newValue === '0'));
  }
}

/***/ }),

/***/ "./components/PackSelector.ts":
/*!************************************!*\
  !*** ./components/PackSelector.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelector: () => (/* binding */ PackSelector)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./utils.ts");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class PackSelector extends HTMLElement {
  constructor() {
    var _this;
    super();
    _this = this;
    _defineProperty(this, "onetimeOptions", []);
    _defineProperty(this, "membershipOptions", []);
    /**
     *
     */
    _defineProperty(this, "init", () => {
      var _this$headerEl;
      this.innerHTML = "\n      <h2 data-header class=\"".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.m0, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.uppercase, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontGrotesk, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.text2xl, "\">\n        <span data-header-value></span>\n      </h2>\n      <div data-body class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-gap-10\">\n        <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgWhite, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p2, "\">\n          <rl-button class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex1, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " es-border-gray-200\" data-onetime-tab></rl-button>\n          <rl-button class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex1, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " es-border-gray-200\" data-membership-tab></rl-button>\n        </div>\n        <div class=\"!es-hidden es-grid es-grid-cols-2 es-gap-3\" data-onetime-content>\n        </div>\n        <div class=\"!es-hidden es-grid es-grid-cols-2 es-gap-3\" data-membership-content>\n        </div>\n      </div>\n    ");
      this.headerEl = this.querySelector('h2');
      this.headerValueEl = (_this$headerEl = this.headerEl) === null || _this$headerEl === void 0 ? void 0 : _this$headerEl.querySelector('[data-header-value]');
      this.onetimeTab = this.querySelector('[data-onetime-tab]');
      this.membershipTab = this.querySelector('[data-membership-tab]');
      this.onetimeContent = this.querySelector('[data-onetime-content]');
      this.membershipContent = this.querySelector('[data-membership-content]');
      this.onetimeOptions.forEach(e => this.onetimeContent.insertAdjacentElement('beforeend', e));
      this.membershipOptions.forEach(e => this.membershipContent.insertAdjacentElement('beforeend', e));
      this.onetimeTab.addEventListener('click', () => this.setActiveTab('onetime'));
      this.membershipTab.addEventListener('click', () => this.setActiveTab('membership'));
      this.setActiveTab((0,_utils__WEBPACK_IMPORTED_MODULE_1__.hasSearchParameter)('membership') ? 'membership' : 'onetime');
    });
    /**
     *
     * @param key
     */
    _defineProperty(this, "setActiveTab", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'membership';
      _this.activeTabKey = key;
      var activeTabClasses = "".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgBlue500, " hover:es-bg-blue-700 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite).split(' ');
      if (_this.activeTabKey === 'onetime') {
        var _this$onetimeTab, _this$membershipTab, _this$onetimeContent, _this$membershipConte, _this$getAttribute, _document$querySelect;
        (_this$onetimeTab = _this.onetimeTab) === null || _this$onetimeTab === void 0 || _this$onetimeTab.classList.add(...activeTabClasses);
        (_this$membershipTab = _this.membershipTab) === null || _this$membershipTab === void 0 || _this$membershipTab.classList.remove(...activeTabClasses);
        (_this$onetimeContent = _this.onetimeContent) === null || _this$onetimeContent === void 0 || _this$onetimeContent.classList.remove('!es-hidden');
        (_this$membershipConte = _this.membershipContent) === null || _this$membershipConte === void 0 || _this$membershipConte.classList.add('!es-hidden');
        if (_this.headerValueEl) _this.headerValueEl.innerHTML = (_this$getAttribute = _this.getAttribute('data-onetime-header')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : '';
        (_document$querySelect = document.querySelector('.perk-container')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('es-hidden');
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__.deleteSearchParameter)('membership');
      } else {
        var _this$onetimeTab2, _this$membershipTab2, _this$onetimeContent2, _this$membershipConte2, _this$getAttribute2, _document$querySelect2;
        (_this$onetimeTab2 = _this.onetimeTab) === null || _this$onetimeTab2 === void 0 || _this$onetimeTab2.classList.remove(...activeTabClasses);
        (_this$membershipTab2 = _this.membershipTab) === null || _this$membershipTab2 === void 0 || _this$membershipTab2.classList.add(...activeTabClasses);
        (_this$onetimeContent2 = _this.onetimeContent) === null || _this$onetimeContent2 === void 0 || _this$onetimeContent2.classList.add('!es-hidden');
        (_this$membershipConte2 = _this.membershipContent) === null || _this$membershipConte2 === void 0 || _this$membershipConte2.classList.remove('!es-hidden');
        if (_this.headerValueEl) _this.headerValueEl.innerHTML = (_this$getAttribute2 = _this.getAttribute('data-membership-header')) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : '';
        (_document$querySelect2 = document.querySelector('.perk-container')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('es-hidden');
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__.setSearchParameter)('membership', 'true');
      }
      _this.dispatchEvent(new CustomEvent('onChangeTab', {
        detail: {
          key: _this.activeTabKey
        },
        bubbles: true,
        cancelable: true
      }));
    });
    this.classList.add(..."es-relative es-bg-gray-400 es-gap-5 ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-p-5 md:es-p-10 md:es-min-w-[540px] es-w-full es-max-w-[540px]").split(' '));
    this.onetimeOptions = Array.from(this.querySelectorAll('[data-onetime-option]'));
    this.membershipOptions = Array.from(this.querySelectorAll('[data-membership-option]'));
    this.init();
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-onetime-label', 'data-membership-label', 'data-prize'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _this$onetimeTab3, _this$membershipTab3;
    switch (name) {
      case 'data-onetime-label':
        return (_this$onetimeTab3 = this.onetimeTab) === null || _this$onetimeTab3 === void 0 ? void 0 : _this$onetimeTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-membership-label':
        return (_this$membershipTab3 = this.membershipTab) === null || _this$membershipTab3 === void 0 ? void 0 : _this$membershipTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-prize':
        {
          if (!this.headerEl) return;
          this.headerEl.insertAdjacentHTML('beforeend', "\n          <div class=\"es-flex es-justify-end es-px-10 es-gap-2 items-start es-italic es-uppercase es-text-lg md:es-text-2xl es-font-bold es-font-figtree\">\n          <span class=\"es-text-nowrap\">get <span class=\"blinking es-text-3xl md:es-text-4xl es-font-black  es-text-red-600\">20x</span> more with subscription</span>\n          <svg class=\"blinking es-mt-3 -es-mb-8\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.0\" width=\"20.000000pt\" height=\"25.000000pt\" viewBox=\"0 0 33.000000 41.000000\" preserveAspectRatio=\"xMidYMid meet\">\n            <g transform=\"translate(0.000000,41.000000) scale(0.100000,-0.100000)\" fill=\"#dc2626\" stroke=\"none\">\n              <path d=\"M10 345 c0 -12 13 -15 56 -15 90 0 94 -5 94 -117 l0 -97 -38 37 c-35 35 -62 47 -62 29 0 -4 26 -33 58 -65 l58 -57 57 58 c31 32 57 61 57 65 0 17 -27 4 -62 -30 l-38 -37 0 97 c0 91 -2 100 -25 122 -21 22 -33 25 -90 25 -51 0 -65 -3 -65 -15z\"/>\n            </g>\n          </svg>\n          </div>");
        }
    }
  }
}

/***/ }),

/***/ "./components/PackSelectorMembersOnly.ts":
/*!***********************************************!*\
  !*** ./components/PackSelectorMembersOnly.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorMembersOnly: () => (/* binding */ PackSelectorMembersOnly)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./utils.ts");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class PackSelectorMembersOnly extends HTMLElement {
  constructor() {
    var _this;
    super();
    _this = this;
    _defineProperty(this, "onetimeOptions", []);
    _defineProperty(this, "membershipOptions", []);
    /**
     *
     */
    _defineProperty(this, "init", () => {
      var _this$headerEl;
      this.innerHTML = "\n      <h2 data-header class=\"".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.m0, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.uppercase, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontGrotesk, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.text2xl, "\">\n        <span data-header-value></span>\n      </h2>\n      <div data-body class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-gap-10\">\n        <div class=\"!es-hidden es-grid es-grid-cols-2 es-gap-3\" data-onetime-content>\n        </div>\n        <div class=\"es-grid es-grid-cols-2 es-gap-3\" data-membership-content>\n        </div>\n      </div>\n    ");
      this.headerEl = this.querySelector('h2');
      this.headerValueEl = (_this$headerEl = this.headerEl) === null || _this$headerEl === void 0 ? void 0 : _this$headerEl.querySelector('[data-header-value]');
      this.onetimeTab = this.querySelector('[data-onetime-tab]');
      this.membershipTab = this.querySelector('[data-membership-tab]');
      this.onetimeContent = this.querySelector('[data-onetime-content]');
      this.membershipContent = this.querySelector('[data-membership-content]');
      this.onetimeOptions.forEach(e => this.onetimeContent.insertAdjacentElement('beforeend', e));
      this.membershipOptions.forEach(e => this.membershipContent.insertAdjacentElement('beforeend', e));
      this.onetimeTab.addEventListener('click', () => this.setActiveTab('onetime'));
      this.membershipTab.addEventListener('click', () => this.setActiveTab('membership'));
      this.setActiveTab((0,_utils__WEBPACK_IMPORTED_MODULE_1__.hasSearchParameter)('membership') ? 'membership' : 'onetime');
    });
    /**
     *
     * @param key
     */
    _defineProperty(this, "setActiveTab", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'membership';
      _this.activeTabKey = key;
      var activeTabClasses = "".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgBlue500, " hover:es-bg-blue-700 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite).split(' ');
      if (_this.activeTabKey === 'onetime') {
        var _this$onetimeTab, _this$membershipTab, _this$onetimeContent, _this$membershipConte, _this$getAttribute, _document$querySelect;
        (_this$onetimeTab = _this.onetimeTab) === null || _this$onetimeTab === void 0 || _this$onetimeTab.classList.add(...activeTabClasses);
        (_this$membershipTab = _this.membershipTab) === null || _this$membershipTab === void 0 || _this$membershipTab.classList.remove(...activeTabClasses);
        (_this$onetimeContent = _this.onetimeContent) === null || _this$onetimeContent === void 0 || _this$onetimeContent.classList.remove('!es-hidden');
        (_this$membershipConte = _this.membershipContent) === null || _this$membershipConte === void 0 || _this$membershipConte.classList.add('!es-hidden');
        if (_this.headerValueEl) _this.headerValueEl.innerHTML = (_this$getAttribute = _this.getAttribute('data-onetime-header')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : '';
        (_document$querySelect = document.querySelector('.perk-container')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('es-hidden');
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__.deleteSearchParameter)('membership');
      } else {
        var _this$onetimeTab2, _this$membershipTab2, _this$onetimeContent2, _this$membershipConte2, _this$getAttribute2, _document$querySelect2;
        (_this$onetimeTab2 = _this.onetimeTab) === null || _this$onetimeTab2 === void 0 || _this$onetimeTab2.classList.remove(...activeTabClasses);
        (_this$membershipTab2 = _this.membershipTab) === null || _this$membershipTab2 === void 0 || _this$membershipTab2.classList.add(...activeTabClasses);
        (_this$onetimeContent2 = _this.onetimeContent) === null || _this$onetimeContent2 === void 0 || _this$onetimeContent2.classList.add('!es-hidden');
        (_this$membershipConte2 = _this.membershipContent) === null || _this$membershipConte2 === void 0 || _this$membershipConte2.classList.remove('!es-hidden');
        if (_this.headerValueEl) _this.headerValueEl.innerHTML = (_this$getAttribute2 = _this.getAttribute('data-membership-header')) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : '';
        (_document$querySelect2 = document.querySelector('.perk-container')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('es-hidden');
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__.setSearchParameter)('membership', 'true');
      }
      _this.dispatchEvent(new CustomEvent('onChangeTab', {
        detail: {
          key: _this.activeTabKey
        },
        bubbles: true,
        cancelable: true
      }));
    });
    this.classList.add(..."es-relative es-bg-gray-400 es-gap-5 ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-p-5 md:es-p-10 md:es-min-w-[540px] es-w-full es-max-w-[540px]").split(' '));
    this.onetimeOptions = Array.from(this.querySelectorAll('[data-onetime-option]'));
    this.membershipOptions = Array.from(this.querySelectorAll('[data-membership-option]'));
    this.init();
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-onetime-label', 'data-membership-label', 'data-prize'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _this$onetimeTab3, _this$membershipTab3;
    switch (name) {
      case 'data-onetime-label':
        return (_this$onetimeTab3 = this.onetimeTab) === null || _this$onetimeTab3 === void 0 ? void 0 : _this$onetimeTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-membership-label':
        return (_this$membershipTab3 = this.membershipTab) === null || _this$membershipTab3 === void 0 ? void 0 : _this$membershipTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-prize':
        {
          if (!this.headerEl) return;
          this.headerEl.insertAdjacentHTML('beforeend', "\n          <div class=\"es-flex es-justify-end es-px-10 es-gap-2 items-start es-italic es-uppercase es-text-lg md:es-text-2xl es-font-bold es-font-figtree\">\n          <span class=\"es-text-nowrap\">get <span class=\"blinking es-text-3xl md:es-text-4xl es-font-black  es-text-red-600\">20x</span> more with subscription</span>\n          <svg class=\"blinking es-mt-3 -es-mb-8\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.0\" width=\"20.000000pt\" height=\"25.000000pt\" viewBox=\"0 0 33.000000 41.000000\" preserveAspectRatio=\"xMidYMid meet\">\n            <g transform=\"translate(0.000000,41.000000) scale(0.100000,-0.100000)\" fill=\"#dc2626\" stroke=\"none\">\n              <path d=\"M10 345 c0 -12 13 -15 56 -15 90 0 94 -5 94 -117 l0 -97 -38 37 c-35 35 -62 47 -62 29 0 -4 26 -33 58 -65 l58 -57 57 58 c31 32 57 61 57 65 0 17 -27 4 -62 -30 l-38 -37 0 97 c0 91 -2 100 -25 122 -21 22 -33 25 -90 25 -51 0 -65 -3 -65 -15z\"/>\n            </g>\n          </svg>\n          </div>");
        }
    }
  }
}

/***/ }),

/***/ "./components/PackSelectorNewDesign.ts":
/*!*********************************************!*\
  !*** ./components/PackSelectorNewDesign.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorNewDesign: () => (/* binding */ PackSelectorNewDesign)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./utils.ts");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class PackSelectorNewDesign extends HTMLElement {
  constructor() {
    var _this;
    super();
    _this = this;
    _defineProperty(this, "onetimeOptions", []);
    _defineProperty(this, "membershipOptions", []);
    /**
     *
     */
    _defineProperty(this, "init", () => {
      this.innerHTML = "\n      <div data-body class=\"new-design-pack-banner-selector\">\n        <div class=\"new-design-pack-banner-selector-header\">\n          <rl-button class=\"new-design-pack-banner-selector-header-btn\" data-onetime-tab></rl-button>\n          <rl-button class=\"new-design-pack-banner-selector-header-btn new-design-pack-banner-selector-header-btn--membership\" data-membership-tab></rl-button>\n        </div>\n        <div class=\"!es-hidden new-design-pack-banner-selector-grid\" data-onetime-content>\n        </div>\n        <div class=\"!es-hidden new-design-pack-banner-selector-grid\" data-membership-content>\n        </div>\n      </div>\n    ";
      this.headerEl = this.querySelector('h2');
      this.onetimeTab = this.querySelector('[data-onetime-tab]');
      this.membershipTab = this.querySelector('[data-membership-tab]');
      this.onetimeContent = this.querySelector('[data-onetime-content]');
      this.membershipContent = this.querySelector('[data-membership-content]');
      this.onetimeOptions.forEach(e => this.onetimeContent.insertAdjacentElement('beforeend', e));
      this.membershipOptions.forEach(e => this.membershipContent.insertAdjacentElement('beforeend', e));
      this.onetimeTab.addEventListener('click', () => this.setActiveTab('onetime'));
      this.membershipTab.addEventListener('click', () => this.setActiveTab('membership'));
      this.setActiveTab((0,_utils__WEBPACK_IMPORTED_MODULE_0__.hasSearchParameter)('membership') ? 'membership' : 'onetime');
    });
    /**
     *
     * @param key
     */
    _defineProperty(this, "setActiveTab", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'membership';
      _this.activeTabKey = key;
      var activeTabClasses = "new-design-pack-banner-selector-header-btn--active".split(' ');
      if (_this.activeTabKey === 'onetime') {
        var _this$onetimeTab, _this$membershipTab, _this$onetimeContent, _this$membershipConte;
        (_this$onetimeTab = _this.onetimeTab) === null || _this$onetimeTab === void 0 || _this$onetimeTab.classList.add(...activeTabClasses);
        (_this$membershipTab = _this.membershipTab) === null || _this$membershipTab === void 0 || _this$membershipTab.classList.remove(...activeTabClasses);
        (_this$onetimeContent = _this.onetimeContent) === null || _this$onetimeContent === void 0 || _this$onetimeContent.classList.remove('!es-hidden');
        (_this$membershipConte = _this.membershipContent) === null || _this$membershipConte === void 0 || _this$membershipConte.classList.add('!es-hidden');
        (0,_utils__WEBPACK_IMPORTED_MODULE_0__.deleteSearchParameter)('membership');
      } else {
        var _this$membershipTab2, _this$onetimeTab2, _this$onetimeContent2, _this$membershipConte2;
        (_this$membershipTab2 = _this.membershipTab) === null || _this$membershipTab2 === void 0 || _this$membershipTab2.classList.add(...activeTabClasses);
        (_this$onetimeTab2 = _this.onetimeTab) === null || _this$onetimeTab2 === void 0 || _this$onetimeTab2.classList.remove(...activeTabClasses);
        (_this$onetimeContent2 = _this.onetimeContent) === null || _this$onetimeContent2 === void 0 || _this$onetimeContent2.classList.add('!es-hidden');
        (_this$membershipConte2 = _this.membershipContent) === null || _this$membershipConte2 === void 0 || _this$membershipConte2.classList.remove('!es-hidden');
        (0,_utils__WEBPACK_IMPORTED_MODULE_0__.setSearchParameter)('membership', 'true');
      }
      _this.dispatchEvent(new CustomEvent('onChangeTab', {
        detail: {
          key: _this.activeTabKey
        },
        bubbles: true,
        cancelable: true
      }));
    });
    this.classList.add('new-design-pack-selector');
    this.onetimeOptions = Array.from(this.querySelectorAll('[data-onetime-option]'));
    this.membershipOptions = Array.from(this.querySelectorAll('[data-membership-option]'));
    this.init();
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-onetime-label', 'data-membership-label', 'data-prize'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _this$onetimeTab3, _this$membershipTab3;
    switch (name) {
      case 'data-onetime-label':
        return (_this$onetimeTab3 = this.onetimeTab) === null || _this$onetimeTab3 === void 0 ? void 0 : _this$onetimeTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-membership-label':
        newValue = "<span>".concat(newValue, "</span><span class=\"new-design-pack-banner-selector-btn-badge\">GET 20X MORE</span>");
        return (_this$membershipTab3 = this.membershipTab) === null || _this$membershipTab3 === void 0 ? void 0 : _this$membershipTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-prize':
        {
          if (!this.headerEl) return;
          this.headerEl.insertAdjacentHTML('beforeend', "");
        }
    }
  }
}

/***/ }),

/***/ "./components/PackSelectorOption.ts":
/*!******************************************!*\
  !*** ./components/PackSelectorOption.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorOption: () => (/* binding */ PackSelectorOption),
/* harmony export */   Perk: () => (/* binding */ Perk)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./utils.ts");
/* harmony import */ var _services_CartApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/CartApi */ "./services/CartApi.ts");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./icons */ "./components/icons/index.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class PackSelectorOption extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "beforeEntries", null);
    _defineProperty(this, "entries", null);
    _defineProperty(this, "perkEls", []);
    _defineProperty(this, "addToCart", () => {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var propertyName = this.getAttribute('data-property-name');
      var propertyValue = this.getAttribute('data-property-value');
      var sellingPlanId = this.getAttribute('data-selling-plan-id');
      var properties = {};
      if (propertyName && propertyValue) {
        properties[propertyName] = propertyValue;
      }
      if (sellingPlanId) {
        properties["Double the cash and entries in ALL giveaways"] = "✓";
        properties["Double Entries on all purchases"] = "✓";
      }
      var addCartParams = _objectSpread(_objectSpread({}, sellingPlanId ? {
        selling_plan: sellingPlanId
      } : {}), Object.keys(properties).length ? {
        properties
      } : {});
      this.atcButtonEl.setLoading();
      var quantity = 1;
      _services_CartApi__WEBPACK_IMPORTED_MODULE_2__["default"].addItem(+variantId, quantity, addCartParams).then(() => {
        this.dispatchEvent(new CustomEvent('onAddToCart', {
          detail: {
            sellingPlanId: sellingPlanId !== null && sellingPlanId !== void 0 && sellingPlanId.length ? +sellingPlanId : null,
            variantId: variantId !== null && variantId !== void 0 && variantId.length ? +variantId : null,
            quantity
          },
          bubbles: true,
          cancelable: true
        }));
        //TODO NEED USE EVENT ADD_TO_CART START
        try {
          var PUB_SUB_EVENTS = {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            variantChange: 'variant-change',
            cartError: 'cart-error'
          };
          if (sellingPlanId) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'Membership Upgrade', {
                'event_category': 'Membership',
                'event_label': 'Upgrade to Membership'
              });
            }
            if (typeof window.publish === 'function') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries-membership',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity,
                  'selling_plan': sellingPlanId
                }
              });
            }
            setTimeout(() => {
              var cartDrawer = document.querySelector('cart-drawer');
              var emptyInnerDrawer = document.querySelector('.drawer__inner-empty');
              var upsellPopup = document.querySelector('.upsell-modal-wrapper');
              // Check if the upsell modal has been seen on membership page
              var hasSeenUpsellModal = document.cookie.includes('upsell_modal=');
              if (!hasSeenUpsellModal) {
                if (variantId == '40630387671128') {
                  var _document$querySelect;
                  (_document$querySelect = document.querySelector('.tier-element[data-variant-id="42753544814680"]')) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove('hidden');
                } else if (variantId == '40099167371352') {
                  var _document$querySelect2;
                  (_document$querySelect2 = document.querySelector('.tier-element[data-variant-id="42753544847448"]')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('hidden');
                } else if (variantId == '40099167469656') {
                  var _document$querySelect3;
                  (_document$querySelect3 = document.querySelector('.tier-element[data-variant-id="42753544880216"]')) === null || _document$querySelect3 === void 0 || _document$querySelect3.classList.remove('hidden');
                } else if (variantId == '40099167502424') {
                  var _document$querySelect4;
                  (_document$querySelect4 = document.querySelector('.tier-element[data-variant-id="42753544912984"]')) === null || _document$querySelect4 === void 0 || _document$querySelect4.classList.remove('hidden');
                }
                if (upsellPopup) {
                  upsellPopup.classList.add('active');
                }
              }
              if (cartDrawer) {
                cartDrawer.classList.add('active');
                cartDrawer.classList.remove('is-empty');
              }
              if (emptyInnerDrawer) {
                emptyInnerDrawer.classList.add('es-hidden');
              }
              document.dispatchEvent(new Event('cartUpdated'));
              this.atcButtonEl.setLoading(false);
            }, 500);
          } else {
            if (typeof window.publish === 'function') {
              typeof window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity
                }
              });
            }
            // Check if the upsell modal has been seen on membership page
            var hasSeenOneTimeModal = document.cookie.includes('onetime_modal=');
            var oneTimeUpsellPopup = document.querySelector('.onetime-modal-wrapper');
            if (!hasSeenOneTimeModal) {
              if (oneTimeUpsellPopup) {
                oneTimeUpsellPopup.classList.add('active');
              }
            }
          }
        } catch (e) {
          console.log('[ERROR][WITH ADD TO CART] Error: ', (e === null || e === void 0 ? void 0 : e.message) || e);
        }
        //TODO NEED USE EVENT ADD_TO_CART START
        setTimeout(() => {
          var cartDrawer = document.querySelector('cart-drawer');
          var emptyInnerDrawer = document.querySelector('.drawer__inner-empty');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            cartDrawer.classList.remove('is-empty');
          }
          if (emptyInnerDrawer) {
            emptyInnerDrawer.classList.add('es-hidden');
          }
          document.dispatchEvent(new Event('cartUpdated'));
          this.atcButtonEl.setLoading(false);
        }, 500);
      }).catch(() => {
        this.atcButtonEl.setLoading(false);
      });
    });
    /**
     *
     */
    _defineProperty(this, "setAsPopular", () => {
      var badge = "<span class=\"es-block es-text-nowrap es-absolute es-right-[10px] -es-top-[14px] sm:-es-top-[17px] ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgWhite, " es-rounded-3xl es-border-red-600 es-p-[1px]\"><span class=\"es-text-lg sm:es-text-xl es-rounded-3xl es-block es-bg-red-600 es-py-1 sm:es-py-2 es-px-4 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite, "\" data-badge>\uD83D\uDD25 Most Popular</span></span>");
      this.insertAdjacentHTML('afterbegin', badge);
      this.classList.remove(..."es-border-transparent".split(' '));
      this.classList.add(..."es-border-red-600".split(' '));
    });
    /**
     *
     */
    _defineProperty(this, "setSoldOut", () => {
      this.atcButtonEl.setDisable();
      this.atcButtonEl.setLabel('Sold out');
    });
    this.classList.add(..."es-bg-gray-200 ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.relative, " !es-pt-8 es-p-2 md:es-p-5 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyBetween, " es-border-[2px] es-border-solid es-border-transparent es-flex-col es-pt-8").split(' '));
    this.perkEls = Array.from(this.querySelectorAll('rl-perk'));
    this.innerHTML = "\n      <div class=\"".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap6, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.itemsStart, " es-w-full\" data-content>\n        <rl-wallpaper></rl-wallpaper>\n        <div class=\"es-flex es-gap-6 es-justify-between es-w-full es-flex-col es-items-start\">\n          <span class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, "\" data-prices>\n            <span data-before-price class=\"es-strike-price empty:es-hidden ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n            <span data-price class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          </span>\n          <span class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " es-gap-0 es-items-start es-flex-col\">\n            <span data-before-entries class=\"es-strike-price empty:es-hidden ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n            <span data-entries class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          </span>\n        </div>\n      </div>\n      <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-gap-5 es-flex-1 es-justify-between !es-w-auto -es-mx-2 md:-es-mx-5\" data-atc>\n        <ul data-perks class=\"es-flex es-flex-col es-gap-3 es-w-full es-m-0 es-p-0 es-list-none empty:es-hidden es-border es-border-solid es-border-transparent es-border-t-gray-300 es-pt-2 es-px-2 md:es-pt-5 md:es-px-5\"></ul>\n        <rl-button class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgBlue500, " hover:es-bg-blue-700 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " sm:es-max-w-[170px] md:es-max-w-[150px] es-mx-2 md:es-mx-5\" data-atc-btn data-label=\"Enter Now\"></rl-button>\n      </div>\n      <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.absolute, " es-top-16 md:es-top-14 es-bottom-unset es-right-3 es-opacity-20 es-w-[70px] es-h-[38px] md:es-w-[90px] md:es-h-[50px]\" data-image></div>\n    ");
    this.wallpaperEl = this.querySelector('rl-wallpaper');
    this.beforeEntriesEl = this.querySelector('[data-before-entries]');
    this.entriesEl = this.querySelector('[data-entries]');
    this.beforePriceEl = this.querySelector('[data-before-price]');
    this.priceEl = this.querySelector('[data-price]');
    this.imageEl = this.querySelector('[data-image]');
    this.atcButtonEl = this.querySelector('[data-atc-btn]');
    this.perkEls.forEach(i => {
      this.querySelector('[data-perks]').insertAdjacentElement('beforeend', i);
    });
    this.atcButtonEl.addEventListener('click', this.addToCart);
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-wallpaper', 'data-before-entries', 'data-entries', 'data-price', 'data-before-price', 'data-image', 'data-popular', 'data-variant-available'];
  }
  /**
   *
   */
  setBeforeEntriesValue() {
    this.beforeEntriesEl.innerHTML = this.beforeEntries && this.entries !== this.beforeEntries ? (0,_utils__WEBPACK_IMPORTED_MODULE_1__.toNumber)(this.beforeEntries) : '';
  }
  /**
   *
   */
  setEntriesValue() {
    this.entriesEl.innerHTML = this.entries ? "<span class=\"es-text-3xl md:es-text-4xl xl:es-text-5xl\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toNumber)(this.entries), "</span> Entr").concat(this.entries > 1 ? 'ies' : 'y') : '';
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-wallpaper':
        if (newValue && newValue !== null && newValue !== void 0 && newValue.length) this.wallpaperEl.setValue(+newValue);
        break;
      case 'data-before-entries':
        {
          this.beforeEntries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          this.setBeforeEntriesValue();
          break;
        }
      case 'data-entries':
        {
          this.entries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          this.setBeforeEntriesValue();
          break;
        }
      // case 'data-before-price':
      //   this.beforePriceEl.innerHTML = newValue?.length ? toMoney(+newValue) : ''
      //   break
      case 'data-price':
        {
          if (newValue !== null && newValue !== void 0 && newValue.length) {
            var pricePerMonth = +newValue;
            var pricePerDay = pricePerMonth / 30; // Assuming a 30-day month
            var isMembership = this.hasAttribute('data-selling-plan-id'); // Check if membership
            if (isMembership) {
              this.priceEl.innerHTML = "\n                      <span class=\"md:es-text-[5rem] es-text-[35px] es-font-bold break-down-price es-italic es-mb-[8px]\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(pricePerDay), "</span>\n                      <div class=\"es-text-[14px] mt-[8px] md:es-text-[16px] es-text-white es-uppercase es-mt-[8px] es-italic tracking-normal\">Per Day (").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(pricePerMonth), " / Mo)</div>\n                  ");
            } else {
              this.priceEl.innerHTML = "\n                      <span class=\"es-text-[4rem] es-font-bold break-down-price es-italic\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(pricePerMonth), "</span>\n                  ");
            }
          } else {
            this.priceEl.innerHTML = '';
          }
          break;
        }
      case 'data-image':
        this.imageEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<img class=\"es-w-full es-h-full es-object-contain\" src=\"".concat(newValue, "\" alt=\"\"/>") : '';
        break;
      case 'data-popular':
        {
          var isPopular = !(newValue === 'false' || newValue === '0');
          if (isPopular) this.setAsPopular();
        }
        break;
      case 'data-variant-available':
        {
          var isAvailable = !(newValue === 'false' || newValue === '0');
          if (!isAvailable) this.setSoldOut();
        }
        break;
    }
  }
}
var icons = {
  percent: _icons__WEBPACK_IMPORTED_MODULE_3__.circlePercentIcon,
  prize: _icons__WEBPACK_IMPORTED_MODULE_3__.prizeIcon,
  doublePrize: _icons__WEBPACK_IMPORTED_MODULE_3__.doublePrizeIcon
};
class Perk extends HTMLElement {
  constructor() {
    super();
    this.classList.add(..."es-flex es-gap-5 es-items-start".split(' '));
    var iconTemplate = this.dataset.icon && icons[this.dataset.icon] ? icons[this.dataset.icon]('es-min-w-[15px] es-w-[15px] es-min-h-[15px] es-h-[15px] es-text-blue-500') : '';
    this.innerHTML = "\n      ".concat(iconTemplate, "<span class=\"es-font-bold es-text-md md:es-text-xl es-leading-none\">").concat(this.dataset.value, "</span>\n    ");
  }
}

/***/ }),

/***/ "./components/PackSelectorOptionMembersOnly.ts":
/*!*****************************************************!*\
  !*** ./components/PackSelectorOptionMembersOnly.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorOptionMembersOnly: () => (/* binding */ PackSelectorOptionMembersOnly),
/* harmony export */   Perk: () => (/* binding */ Perk)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./utils.ts");
/* harmony import */ var _services_CartApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/CartApi */ "./services/CartApi.ts");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./icons */ "./components/icons/index.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class PackSelectorOptionMembersOnly extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "beforeEntries", null);
    _defineProperty(this, "entries", null);
    _defineProperty(this, "perkEls", []);
    _defineProperty(this, "addToCart", () => {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var propertyName = this.getAttribute('data-property-name');
      var propertyValue = this.getAttribute('data-property-value');
      var sellingPlanId = this.getAttribute('data-selling-plan-id');
      var properties = {};
      if (propertyName && propertyValue) {
        properties[propertyName] = propertyValue;
      }
      if (sellingPlanId) {
        properties["Double the cash and entries in ALL giveaways"] = "✓";
        properties["Double Entries on all purchases"] = "✓";
      }
      var addCartParams = _objectSpread(_objectSpread({}, sellingPlanId ? {
        selling_plan: sellingPlanId
      } : {}), Object.keys(properties).length ? {
        properties
      } : {});
      this.atcButtonEl.setLoading();
      var quantity = 1;
      _services_CartApi__WEBPACK_IMPORTED_MODULE_2__["default"].addItem(+variantId, quantity, addCartParams).then(() => {
        this.dispatchEvent(new CustomEvent('onAddToCart', {
          detail: {
            sellingPlanId: sellingPlanId !== null && sellingPlanId !== void 0 && sellingPlanId.length ? +sellingPlanId : null,
            variantId: variantId !== null && variantId !== void 0 && variantId.length ? +variantId : null,
            quantity
          },
          bubbles: true,
          cancelable: true
        }));
        //TODO NEED USE EVENT ADD_TO_CART START
        try {
          var PUB_SUB_EVENTS = {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            variantChange: 'variant-change',
            cartError: 'cart-error'
          };
          if (sellingPlanId) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'Membership Upgrade', {
                'event_category': 'Membership',
                'event_label': 'Upgrade to Membership'
              });
            }
            if (typeof window.publish === 'function') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries-membership',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity,
                  'selling_plan': sellingPlanId
                }
              });
            }
          } else {
            if (typeof window.publish === 'function') {
              typeof window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity
                }
              });
            }
          }
        } catch (e) {
          console.log('[ERROR][WITH ADD TO CART] Error: ', (e === null || e === void 0 ? void 0 : e.message) || e);
        }
        //TODO NEED USE EVENT ADD_TO_CART START
        setTimeout(() => {
          var cartDrawer = document.querySelector('cart-drawer');
          var emptyInnerDrawer = document.querySelector('.drawer__inner-empty');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            cartDrawer.classList.remove('is-empty');
          }
          if (emptyInnerDrawer) {
            emptyInnerDrawer.classList.add('es-hidden');
          }
          document.dispatchEvent(new Event('cartUpdated'));
          this.atcButtonEl.setLoading(false);
        }, 500);
      }).catch(() => {
        this.atcButtonEl.setLoading(false);
      });
    });
    /**
     *
     */
    _defineProperty(this, "setAsPopular", () => {
      var badge = "<span class=\"es-block es-text-nowrap es-absolute es-right-[10px] -es-top-[14px] sm:-es-top-[17px] ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgWhite, " es-rounded-3xl es-border-red-600 es-p-[1px]\"><span class=\"es-text-lg sm:es-text-xl es-rounded-3xl es-block es-bg-red-600 es-py-1 sm:es-py-2 es-px-4 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite, "\" data-badge>\uD83D\uDD25 Most Popular</span></span>");
      this.insertAdjacentHTML('afterbegin', badge);
      this.classList.remove(..."es-border-transparent".split(' '));
      this.classList.add(..."es-border-red-600".split(' '));
    });
    /**
     *
     */
    _defineProperty(this, "setSoldOut", () => {
      this.atcButtonEl.setDisable();
      this.atcButtonEl.setLabel('Sold out');
    });
    this.classList.add(..."es-bg-gray-200 ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.relative, " !es-pt-8 es-p-2 md:es-p-5 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyBetween, " es-border-[2px] es-border-solid es-border-transparent es-flex-col es-pt-8").split(' '));
    this.perkEls = Array.from(this.querySelectorAll('rl-perk'));
    this.innerHTML = "\n      <div class=\"".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap6, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.itemsStart, " es-w-full\" data-content>\n        <rl-wallpaper></rl-wallpaper>\n        <div class=\"es-flex es-gap-6 es-justify-between es-w-full es-flex-col es-items-start\">\n          <span class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, "\" data-prices>\n            <span data-before-price class=\"es-strike-price empty:es-hidden ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n            <span data-price class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          </span>\n          <span class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " es-gap-0 es-items-start es-flex-col\">\n            <span data-before-entries class=\"es-strike-price empty:es-hidden ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n            <span data-entries class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          </span>\n        </div>\n      </div>\n      <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-gap-5 es-flex-1 es-justify-between !es-w-auto -es-mx-2 md:-es-mx-5\" data-atc>\n        <ul data-perks class=\"es-flex es-flex-col es-gap-3 es-w-full es-m-0 es-p-0 es-list-none empty:es-hidden es-border es-border-solid es-border-transparent es-border-t-gray-300 es-pt-2 es-px-2 md:es-pt-5 md:es-px-5\"></ul>\n        <rl-button class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgBlue500, " hover:es-bg-blue-700 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " sm:es-max-w-[170px] md:es-max-w-[150px] es-mx-2 md:es-mx-5\" data-atc-btn data-label=\"Enter Now\"></rl-button>\n      </div>\n      <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.absolute, " es-top-16 md:es-top-14 es-bottom-unset es-right-3 es-opacity-20 es-w-[70px] es-h-[38px] md:es-w-[90px] md:es-h-[50px]\" data-image></div>\n    ");
    this.wallpaperEl = this.querySelector('rl-wallpaper');
    this.beforeEntriesEl = this.querySelector('[data-before-entries]');
    this.entriesEl = this.querySelector('[data-entries]');
    this.beforePriceEl = this.querySelector('[data-before-price]');
    this.priceEl = this.querySelector('[data-price]');
    this.imageEl = this.querySelector('[data-image]');
    this.atcButtonEl = this.querySelector('[data-atc-btn]');
    this.perkEls.forEach(i => {
      this.querySelector('[data-perks]').insertAdjacentElement('beforeend', i);
    });
    this.atcButtonEl.addEventListener('click', this.addToCart);
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-wallpaper', 'data-before-entries', 'data-entries', 'data-price', 'data-before-price', 'data-image', 'data-popular', 'data-variant-available'];
  }
  /**
   *
   */
  setBeforeEntriesValue() {
    this.beforeEntriesEl.innerHTML = this.beforeEntries && this.entries !== this.beforeEntries ? (0,_utils__WEBPACK_IMPORTED_MODULE_1__.toNumber)(this.beforeEntries) : '';
  }
  /**
   *
   */
  setEntriesValue() {
    this.entriesEl.innerHTML = this.entries ? "<span class=\"es-text-3xl md:es-text-4xl xl:es-text-5xl\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toNumber)(this.entries), "</span> Entr").concat(this.entries > 1 ? 'ies' : 'y') : '';
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-wallpaper':
        if (newValue && newValue !== null && newValue !== void 0 && newValue.length) this.wallpaperEl.setValue(+newValue);
        break;
      case 'data-before-entries':
        {
          this.beforeEntries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          this.setBeforeEntriesValue();
          break;
        }
      case 'data-entries':
        {
          this.entries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          this.setBeforeEntriesValue();
          break;
        }
      // case 'data-before-price':
      //   this.beforePriceEl.innerHTML = newValue?.length ? toMoney(+newValue) : ''
      //   break
      case 'data-price':
        {
          if (newValue !== null && newValue !== void 0 && newValue.length) {
            var pricePerMonth = +newValue;
            var pricePerDay = pricePerMonth / 30; // Assuming a 30-day month
            var isMembership = this.hasAttribute('data-selling-plan-id'); // Check if membership
            if (isMembership) {
              this.priceEl.innerHTML = "\n                      <span class=\"md:es-text-[5rem] es-text-[35px] es-font-bold break-down-price es-italic es-mb-[8px]\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(pricePerDay), "</span>\n                      <div class=\"es-text-[14px] mt-[8px] md:es-text-[16px] es-text-white es-uppercase es-mt-[8px] es-italic tracking-normal\">Per Day (").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(pricePerMonth), " / Mo)</div>\n                  ");
            } else {
              this.priceEl.innerHTML = "\n                      <span class=\"es-text-[4rem] es-font-bold break-down-price es-italic\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(pricePerMonth), "</span>\n                  ");
            }
          } else {
            this.priceEl.innerHTML = '';
          }
          break;
        }
      case 'data-image':
        this.imageEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<img class=\"es-w-full es-h-full es-object-contain\" src=\"".concat(newValue, "\" alt=\"\"/>") : '';
        break;
      case 'data-popular':
        {
          var isPopular = !(newValue === 'false' || newValue === '0');
          if (isPopular) this.setAsPopular();
        }
        break;
      case 'data-variant-available':
        {
          var isAvailable = !(newValue === 'false' || newValue === '0');
          if (!isAvailable) this.setSoldOut();
        }
        break;
    }
  }
}
var icons = {
  percent: _icons__WEBPACK_IMPORTED_MODULE_3__.circlePercentIcon,
  prize: _icons__WEBPACK_IMPORTED_MODULE_3__.prizeIcon,
  doublePrize: _icons__WEBPACK_IMPORTED_MODULE_3__.doublePrizeIcon
};
class Perk extends HTMLElement {
  constructor() {
    super();
    this.classList.add(..."es-flex es-gap-5 es-items-start".split(' '));
    var iconTemplate = this.dataset.icon && icons[this.dataset.icon] ? icons[this.dataset.icon]('es-min-w-[15px] es-w-[15px] es-min-h-[15px] es-h-[15px] es-text-blue-500') : '';
    this.innerHTML = "\n      ".concat(iconTemplate, "<span class=\"es-font-bold es-text-md md:es-text-xl es-leading-none\">").concat(this.dataset.value, "</span>\n    ");
  }
}

/***/ }),

/***/ "./components/PackSelectorOptionNewDesign.ts":
/*!***************************************************!*\
  !*** ./components/PackSelectorOptionNewDesign.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorOptionNewDesign: () => (/* binding */ PackSelectorOptionNewDesign),
/* harmony export */   PerkNewDesign: () => (/* binding */ PerkNewDesign)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./utils.ts");
/* harmony import */ var _services_CartApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../services/CartApi */ "./services/CartApi.ts");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./icons */ "./components/icons/index.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class PackSelectorOptionNewDesign extends HTMLElement {
  constructor() {
    super();
    // public wallpaperEl: Wallpaper
    _defineProperty(this, "beforeEntries", null);
    _defineProperty(this, "entries", null);
    _defineProperty(this, "perkEls", []);
    _defineProperty(this, "addToCart", () => {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var propertyName = this.getAttribute('data-property-name');
      var propertyValue = this.getAttribute('data-property-value');
      var sellingPlanId = this.getAttribute('data-selling-plan-id');
      var addCartParams = _objectSpread(_objectSpread({}, sellingPlanId ? {
        selling_plan: sellingPlanId
      } : {}), !!propertyName && !!propertyValue ? {
        properties: {
          [propertyName]: propertyValue
        }
      } : {});
      this.atcButtonEl.setLoading();
      var quantity = 1;
      _services_CartApi__WEBPACK_IMPORTED_MODULE_1__["default"].addItem(+variantId, quantity, addCartParams).then(() => {
        this.dispatchEvent(new CustomEvent('onAddToCart', {
          detail: {
            sellingPlanId: sellingPlanId !== null && sellingPlanId !== void 0 && sellingPlanId.length ? +sellingPlanId : null,
            variantId: variantId !== null && variantId !== void 0 && variantId.length ? +variantId : null,
            quantity
          },
          bubbles: true,
          cancelable: true
        }));
        //TODO NEED USE EVENT ADD_TO_CART START
        try {
          var PUB_SUB_EVENTS = {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            variantChange: 'variant-change',
            cartError: 'cart-error'
          };
          if (sellingPlanId) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'Membership Upgrade', {
                'event_category': 'Membership',
                'event_label': 'Upgrade to Membership'
              });
            }
            if (typeof window.publish === 'function') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries-membership',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity,
                  'selling_plan': sellingPlanId
                }
              });
            }
          } else {
            if (typeof window.publish === 'function') {
              typeof window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity
                }
              });
            }
          }
        } catch (e) {
          console.log('[ERROR][WITH ADD TO CART] Error: ', (e === null || e === void 0 ? void 0 : e.message) || e);
        }
        //TODO NEED USE EVENT ADD_TO_CART START
        setTimeout(() => {
          console.log('item has been added to cart');
          var cartDrawer = document.querySelector('cart-drawer');
          var emptyInnerDrawer = document.querySelector('.drawer__inner-empty');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            cartDrawer.classList.remove('is-empty');
          }
          if (emptyInnerDrawer) {
            emptyInnerDrawer.classList.add('es-hidden');
          }
          document.dispatchEvent(new Event('cartUpdated'));
          this.atcButtonEl.setLoading(false);
        }, 500);
      }).catch(() => {
        this.atcButtonEl.setLoading(false);
      });
    });
    /**
     *
     */
    _defineProperty(this, "setAsPopular", () => {
      this.setAttribute('is-popular-pack-selector-option', 'true');
    });
    /**
     *
     */
    _defineProperty(this, "setSoldOut", () => {
      this.atcButtonEl.setDisable();
      this.atcButtonEl.setLabel('Sold out');
    });
    this.perkEls = Array.from(this.querySelectorAll('rl-perk-new'));
    this.innerHTML = "\n      <div class=\"new-design-pack-banner-selector-option\" data-content>\n        <div class=\"new-design-pack-banner-selector-option-head\">\n          <div class=\"new-design-pack-banner-selector-entries\" data-entries></div>\n          <span data-price class=\"new-design-pack-banner-selector-price\"></span>\n        </div>\n        <div class=\"new-design-pack-banner-selector-option-body\">\n          <ul data-perks class=\"new-design-pack-banner-selector-perks\"></ul>\n          <rl-button class=\"new-design-pack-banner-selector-button\" data-atc-btn data-label=\"Get Started\"></rl-button>\n        </div>\n      </div>\n      <div class=\"\" data-image></div>\n    ";
    // this.wallpaperEl = this.querySelector('rl-wallpaper') as Wallpaper
    this.entriesEl = this.querySelector('[data-entries]');
    this.beforePriceEl = this.querySelector('[data-before-price]');
    this.priceEl = this.querySelector('[data-price]');
    this.imageEl = this.querySelector('[data-image]');
    this.atcButtonEl = this.querySelector('[data-atc-btn]');
    this.perkEls.forEach(i => {
      this.querySelector('[data-perks]').insertAdjacentElement('beforeend', i);
    });
    this.atcButtonEl.addEventListener('click', this.addToCart);
    this.atcButtonEl.setIcon((0,_icons__WEBPACK_IMPORTED_MODULE_2__.chevronRight)('new-design-pack-banner-selector-button-icon'), 'beforeend');
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-wallpaper', 'data-before-entries', 'data-entries', 'data-price', 'data-before-price', 'data-image', 'data-popular', 'data-variant-available'];
  }
  /**
   *
   */
  /**
   *
   */
  setEntriesValue() {
    console.log('Entries total: ', this.entries);
    this.entriesEl.innerHTML = this.entries ? "<span class=\"new-design-pack-banner-selector-entry-label--most-popular\"><span>Most Popular</span>".concat((0,_icons__WEBPACK_IMPORTED_MODULE_2__.fireBlueIcon)(), "</span><span class=\"new-design-pack-banner-selector-entry-label\">Entr").concat(this.entries > 1 ? 'ies' : 'y', "</span><span class=\"new-design-pack-banner-selector-entry-value\">").concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toNumber)(this.entries), "</span>") : '';
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-wallpaper':
        // if (newValue && newValue?.length) this.wallpaperEl.setValue(+newValue)
        break;
      case 'data-before-entries':
        {
          this.beforeEntries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          break;
        }
      case 'data-entries':
        {
          this.entries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          break;
        }
      // case 'data-before-price':
      //   this.beforePriceEl.innerHTML = newValue?.length ? toMoney(+newValue) : ''
      //   break
      case 'data-price':
        {
          if (newValue !== null && newValue !== void 0 && newValue.length) {
            var pricePerMonth = +newValue;
            var pricePerDay = pricePerMonth / 30; // Assuming a 30-day month
            var isMembership = this.hasAttribute('data-selling-plan-id'); // Check if membership
            if (isMembership) {
              this.priceEl.innerHTML = "\n                      <span class=\"new-design-pack-banner-selector-price-value\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toMoney)(pricePerMonth), "</span><span class=\"new-design-pack-banner-selector-price-label\">/month</span>\n                  ");
            } else {
              this.priceEl.innerHTML = "\n                      <span class=\"new-design-pack-banner-selector-price-value test123\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toMoney)(pricePerMonth), "</span></span>\n                  ");
            }
          } else {
            this.priceEl.innerHTML = '';
          }
          break;
        }
      case 'data-image':
        this.imageEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<img class=\"es-w-full es-h-full es-object-contain\" src=\"".concat(newValue, "\" alt=\"\"/>") : '';
        break;
      case 'data-popular':
        {
          var isPopular = !(newValue === 'false' || newValue === '0');
          if (isPopular) this.setAsPopular();
        }
        break;
      case 'data-variant-available':
        {
          var isAvailable = !(newValue === 'false' || newValue === '0');
          if (!isAvailable) this.setSoldOut();
        }
        break;
    }
  }
}
var icons = {
  wallpaperNewIcon: _icons__WEBPACK_IMPORTED_MODULE_2__.wallpaperNewIcon,
  prizeNewIcon: _icons__WEBPACK_IMPORTED_MODULE_2__.prizeNewIcon,
  membersGiveawayIcon: _icons__WEBPACK_IMPORTED_MODULE_2__.membersGiveawayIcon
};
class PerkNewDesign extends HTMLElement {
  constructor() {
    super();
    this.classList.add('new-design-perk');
    var iconTemplate = this.dataset.icon && icons[this.dataset.icon] ? icons[this.dataset.icon]('new-design-perk-icon') : '';
    this.innerHTML = "\n      ".concat(iconTemplate, "<span class=\"\">").concat(this.dataset.value, "</span>\n    ");
  }
}

/***/ }),

/***/ "./components/PackSelectorOptionNewDesignV2.ts":
/*!*****************************************************!*\
  !*** ./components/PackSelectorOptionNewDesignV2.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorOptionNewDesignV2: () => (/* binding */ PackSelectorOptionNewDesignV2),
/* harmony export */   PerkNewDesign: () => (/* binding */ PerkNewDesign)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./utils.ts");
/* harmony import */ var _services_CartApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../services/CartApi */ "./services/CartApi.ts");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./icons */ "./components/icons/index.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class PackSelectorOptionNewDesignV2 extends HTMLElement {
  constructor() {
    super();
    // public wallpaperEl: Wallpaper
    _defineProperty(this, "beforeEntries", null);
    _defineProperty(this, "entries", null);
    _defineProperty(this, "perkEls", []);
    _defineProperty(this, "addToCart", () => {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var propertyName = this.getAttribute('data-property-name');
      var propertyValue = this.getAttribute('data-property-value');
      var sellingPlanId = this.getAttribute('data-selling-plan-id');
      var addCartParams = _objectSpread(_objectSpread({}, sellingPlanId ? {
        selling_plan: sellingPlanId
      } : {}), !!propertyName && !!propertyValue ? {
        properties: {
          [propertyName]: propertyValue
        }
      } : {});
      this.atcButtonEl.setLoading();
      var quantity = 1;
      _services_CartApi__WEBPACK_IMPORTED_MODULE_1__["default"].addItem(+variantId, quantity, addCartParams).then(() => {
        this.dispatchEvent(new CustomEvent('onAddToCart', {
          detail: {
            sellingPlanId: sellingPlanId !== null && sellingPlanId !== void 0 && sellingPlanId.length ? +sellingPlanId : null,
            variantId: variantId !== null && variantId !== void 0 && variantId.length ? +variantId : null,
            quantity
          },
          bubbles: true,
          cancelable: true
        }));
        //TODO NEED USE EVENT ADD_TO_CART START
        try {
          var PUB_SUB_EVENTS = {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            variantChange: 'variant-change',
            cartError: 'cart-error'
          };
          if (sellingPlanId) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'Membership Upgrade', {
                'event_category': 'Membership',
                'event_label': 'Upgrade to Membership'
              });
            }
            if (typeof window.publish === 'function') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries-membership',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity,
                  'selling_plan': sellingPlanId
                }
              });
            }
          } else {
            if (typeof window.publish === 'function') {
              typeof window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity
                }
              });
            }
          }
        } catch (e) {
          console.log('[ERROR][WITH ADD TO CART] Error: ', (e === null || e === void 0 ? void 0 : e.message) || e);
        }
        //TODO NEED USE EVENT ADD_TO_CART START
        setTimeout(() => {
          var cartDrawer = document.querySelector('cart-drawer');
          var emptyInnerDrawer = document.querySelector('.drawer__inner-empty');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            cartDrawer.classList.remove('is-empty');
          }
          if (emptyInnerDrawer) {
            emptyInnerDrawer.classList.add('es-hidden');
          }
          document.dispatchEvent(new Event('cartUpdated'));
          this.atcButtonEl.setLoading(false);
        }, 500);
      }).catch(() => {
        this.atcButtonEl.setLoading(false);
      });
    });
    /**
     *
     */
    _defineProperty(this, "setAsPopular", () => {
      this.setAttribute('is-popular-pack-selector-option', 'true');
    });
    /**
     *
     */
    _defineProperty(this, "setSoldOut", () => {
      this.atcButtonEl.setDisable();
      this.atcButtonEl.setLabel('Sold out');
    });
    this.perkEls = Array.from(this.querySelectorAll('rl-perk-new'));
    this.innerHTML = "\n      <div class=\"new-design-pack-banner-selector-option-v2\" data-content>\n        <div class=\"new-design-pack-banner-selector-option-head-v2\">\n          <div class=\"new-design-pack-banner-selector-entries\" data-entries></div>\n          <div data-price class=\"new-design-pack-banner-selector-price-v2\"></div>\n        </div>\n        <div class=\"new-design-pack-banner-selector-option-body\">\n          <ul data-perks class=\"new-design-pack-banner-selector-perks\"></ul>\n          <rl-button class=\"new-design-pack-banner-selector-button-v2\" data-atc-btn data-label=\"Get Started\"></rl-button>\n        </div>\n      </div>\n      <div class=\"\" data-image></div>\n    ";
    // this.wallpaperEl = this.querySelector('rl-wallpaper') as Wallpaper
    this.entriesEl = this.querySelector('[data-entries]');
    this.beforePriceEl = this.querySelector('[data-before-price]');
    this.priceEl = this.querySelector('[data-price]');
    this.imageEl = this.querySelector('[data-image]');
    this.atcButtonEl = this.querySelector('[data-atc-btn]');
    this.perkEls.forEach(i => {
      this.querySelector('[data-perks]').insertAdjacentElement('beforeend', i);
    });
    this.atcButtonEl.addEventListener('click', this.addToCart);
    this.atcButtonEl.setIcon((0,_icons__WEBPACK_IMPORTED_MODULE_2__.chevronRight)('new-design-pack-banner-selector-button-icon'), 'beforeend');
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-wallpaper', 'data-before-entries', 'data-entries', 'data-price', 'data-before-price', 'data-image', 'data-popular', 'data-variant-available'];
  }
  /**
   *
   */
  /**
   *
   */
  setEntriesValue() {
    this.entriesEl.innerHTML = this.entries ? "<span class=\"new-design-pack-banner-selector-entry-label-with-value\"><span>".concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toNumber)(this.entries), "</span> <span>Entr").concat(this.entries > 1 ? 'ies' : 'y', "</span></span>") : '';
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-wallpaper':
        // if (newValue && newValue?.length) this.wallpaperEl.setValue(+newValue)
        break;
      case 'data-before-entries':
        {
          this.beforeEntries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          break;
        }
      case 'data-entries':
        {
          this.entries = newValue !== null && newValue !== void 0 && newValue.length ? +newValue : null;
          this.setEntriesValue();
          break;
        }
      // case 'data-before-price':
      //   this.beforePriceEl.innerHTML = newValue?.length ? toMoney(+newValue) : ''
      //   break
      case 'data-price':
        {
          if (newValue !== null && newValue !== void 0 && newValue.length) {
            var pricePerMonth = +newValue;
            var pricePerDay = pricePerMonth / 30; // Assuming a 30-day month
            var isMembership = this.hasAttribute('data-selling-plan-id'); // Check if membership
            if (isMembership) {
              this.priceEl.innerHTML = "\n                      <span class=\"new-design-pack-selector-price-value-v2\"><span>".concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toMoney)(pricePerMonth), "</span><span>/month</span></span>\n                      ").concat(this.dataset.discountValue ? "\n                        <span class=\"new-design-pack-selector-price-discount-v2\"><span>".concat(this.dataset.discountValue, " OFF</span>").concat((0,_icons__WEBPACK_IMPORTED_MODULE_2__.discountIcon)(), "</span>") : '', "\n                  ");
            } else {
              this.priceEl.innerHTML = "\n                      <span class=\"new-design-pack-banner-selector-price-value\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toMoney)(pricePerMonth), "</span><span class=\"new-design-pack-banner-selector-price-label\">/month</span>\n                  ");
            }
          } else {
            this.priceEl.innerHTML = '';
          }
          break;
        }
      case 'data-image':
        this.imageEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<img class=\"es-w-full es-h-full es-object-contain\" src=\"".concat(newValue, "\" alt=\"\"/>") : '';
        break;
      case 'data-popular':
        {
          var isPopular = !(newValue === 'false' || newValue === '0');
          if (isPopular) this.setAsPopular();
        }
        break;
      case 'data-variant-available':
        {
          var isAvailable = !(newValue === 'false' || newValue === '0');
          if (!isAvailable) this.setSoldOut();
        }
        break;
    }
  }
}
var icons = {
  wallpaperNewIcon: _icons__WEBPACK_IMPORTED_MODULE_2__.wallpaperNewIcon,
  prizeNewIcon: _icons__WEBPACK_IMPORTED_MODULE_2__.prizeNewIcon,
  membersGiveawayIcon: _icons__WEBPACK_IMPORTED_MODULE_2__.membersGiveawayIcon
};
class PerkNewDesign extends HTMLElement {
  constructor() {
    super();
    this.classList.add('new-design-perk');
    var iconTemplate = this.dataset.icon && icons[this.dataset.icon] ? icons[this.dataset.icon]('new-design-perk-icon') : '';
    this.innerHTML = "\n      ".concat(iconTemplate, "<span class=\"\">").concat(this.dataset.value, "</span>\n    ");
  }
}
// {{ variant.metafields.custom.membership_discount }}

/***/ }),

/***/ "./components/PackSelectorOptionV2.ts":
/*!********************************************!*\
  !*** ./components/PackSelectorOptionV2.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorOptionV2: () => (/* binding */ PackSelectorOptionV2),
/* harmony export */   Perk: () => (/* binding */ Perk)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./utils.ts");
/* harmony import */ var _services_CartApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/CartApi */ "./services/CartApi.ts");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./icons */ "./components/icons/index.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class PackSelectorOptionV2 extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "perkEls", []);
    _defineProperty(this, "addToCart", () => {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var propertyName = this.getAttribute('data-property-name');
      var propertyValue = this.getAttribute('data-property-value');
      var sellingPlanId = this.getAttribute('data-selling-plan-id');
      var addCartParams = _objectSpread(_objectSpread({}, sellingPlanId ? {
        selling_plan: sellingPlanId
      } : {}), !!propertyName && !!propertyValue ? {
        properties: {
          [propertyName]: propertyValue
        }
      } : {});
      this.atcButtonEl.setLoading();
      var quantity = 1;
      _services_CartApi__WEBPACK_IMPORTED_MODULE_2__["default"].addItem(+variantId, quantity, addCartParams).then(() => {
        this.dispatchEvent(new CustomEvent('onAddToCart', {
          detail: {
            sellingPlanId: sellingPlanId !== null && sellingPlanId !== void 0 && sellingPlanId.length ? +sellingPlanId : null,
            variantId: variantId !== null && variantId !== void 0 && variantId.length ? +variantId : null,
            quantity
          },
          bubbles: true,
          cancelable: true
        }));
        //TODO NEED USE EVENT ADD_TO_CART START
        try {
          var PUB_SUB_EVENTS = {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            variantChange: 'variant-change',
            cartError: 'cart-error'
          };
          if (sellingPlanId) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'Membership Upgrade', {
                'event_category': 'Membership',
                'event_label': 'Upgrade to Membership'
              });
            }
            if (typeof window.publish === 'function') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries-membership',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity,
                  'selling_plan': sellingPlanId
                }
              });
            }
          } else {
            if (typeof window.publish === 'function') {
              typeof window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity
                }
              });
            }
          }
        } catch (e) {
          console.log('[ERROR][WITH ADD TO CART] Error: ', (e === null || e === void 0 ? void 0 : e.message) || e);
        }
        //TODO NEED USE EVENT ADD_TO_CART START
        setTimeout(() => {
          location.href = '/checkout';
        }, 500);
      }).catch(() => {
        this.atcButtonEl.setLoading(false);
      });
    });
    /**
     *
     */
    _defineProperty(this, "setAsPopular", () => {
      var badge = "<span class=\"es-block es-text-nowrap es-absolute es-right-[10px] -es-top-[14px] sm:-es-top-[17px] ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgWhite, " es-rounded-3xl es-border-red-600 es-p-[1px]\"><span class=\"es-text-lg sm:es-text-xl es-rounded-3xl es-block es-bg-red-600 es-py-1 sm:es-py-2 es-px-4 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite, "\" data-badge>\uD83D\uDD25 Most Popular</span></span>");
      this.insertAdjacentHTML('afterbegin', badge);
      this.classList.remove(..."es-border-transparent".split(' '));
      this.classList.add(..."es-border-red-600".split(' '));
    });
    this.classList.add(..."es-bg-gray-200 ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.relative, " !es-pt-8 es-p-2 md:es-p-5 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyBetween, " es-border-[2px] es-border-solid es-border-transparent es-flex-col es-pt-8").split(' '));
    this.perkEls = Array.from(this.querySelectorAll('rl-perk'));
    this.innerHTML = "\n      <div class=\"".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap6, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.itemsStart, " es-w-full\" data-content>\n        <rl-wallpaper></rl-wallpaper>\n        <div class=\"es-flex es-gap-6 es-justify-between es-w-full es-flex-col es-items-start\">\n          <span class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " es-gap-0 es-items-start es-flex-col\">\n            <span data-before-entries class=\"es-strike-price empty:es-hidden ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n            <span data-entries class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          </span>\n          <span class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, "\" data-prices>\n            <span data-before-price class=\"es-strike-price empty:es-hidden ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n            <span data-price class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          </span>\n        </div>\n      </div>\n      <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-gap-5 es-flex-1 es-justify-between !es-w-auto -es-mx-2 md:-es-mx-5\" data-atc>\n        <ul data-perks class=\"es-flex es-flex-col es-gap-3 es-w-full es-m-0 es-p-0 es-list-none empty:es-hidden es-border es-border-solid es-border-transparent es-border-t-gray-300 es-pt-2 es-px-2 md:es-pt-5 md:es-px-5\"></ul>\n        <rl-button class=\"es-bg-[#efbf04] hover:es-bg-[#efbf04] ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " sm:es-max-w-[170px] md:es-max-w-[150px] es-mx-2 md:es-mx-5\" data-atc-btn data-label=\"Enter Now\"></rl-button>\n      </div>\n      <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.absolute, " es-top-16 md:es-top-14 es-bottom-unset es-right-3 es-opacity-20 es-w-[70px] es-h-[38px] md:es-w-[90px] md:es-h-[50px]\" data-image></div>\n    ");
    this.wallpaperEl = this.querySelector('rl-wallpaper');
    this.beforeEntriesEl = this.querySelector('[data-before-entries]');
    this.entriesEl = this.querySelector('[data-entries]');
    this.beforePriceEl = this.querySelector('[data-before-price]');
    this.priceEl = this.querySelector('[data-price]');
    this.imageEl = this.querySelector('[data-image]');
    this.atcButtonEl = this.querySelector('[data-atc-btn]');
    this.perkEls.forEach(i => {
      this.querySelector('[data-perks]').insertAdjacentElement('beforeend', i);
    });
    this.atcButtonEl.addEventListener('click', this.addToCart);
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-wallpaper', 'data-before-entries', 'data-entries', 'data-price', 'data-before-price', 'data-image', 'data-popular'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _this$getAttribute;
    switch (name) {
      case 'data-wallpaper':
        if (newValue && newValue !== null && newValue !== void 0 && newValue.length) this.wallpaperEl.setValue(+newValue);
        break;
      case 'data-before-entries':
        this.beforeEntriesEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? (0,_utils__WEBPACK_IMPORTED_MODULE_1__.toNumber)(+newValue) : '';
        break;
      case 'data-entries':
        this.entriesEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<span class=\"es-text-3xl md:es-text-4xl xl:es-text-5xl\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toNumber)(+newValue), "</span> Entr").concat(+newValue > 1 ? 'ies' : 'y') : '';
        break;
      // case 'data-before-price':
      //   this.beforePriceEl.innerHTML = newValue?.length ? toMoney(+newValue) : ''
      //   break
      case 'data-price':
        this.priceEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? (0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(+newValue) + ((_this$getAttribute = this.getAttribute('data-price-suffix')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : '') : '';
        break;
      case 'data-image':
        this.imageEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<img class=\"es-w-full es-h-full es-object-contain\" src=\"".concat(newValue, "\" alt=\"\"/>") : '';
        break;
      case 'data-popular':
        {
          var isPopular = !(newValue === 'false' || newValue === '0');
          if (isPopular) this.setAsPopular();
        }
        break;
    }
  }
}
var icons = {
  percent: _icons__WEBPACK_IMPORTED_MODULE_3__.circlePercentIcon,
  prize: _icons__WEBPACK_IMPORTED_MODULE_3__.prizeIcon,
  doublePrize: _icons__WEBPACK_IMPORTED_MODULE_3__.doublePrizeIcon
};
class Perk extends HTMLElement {
  constructor() {
    super();
    this.classList.add(..."es-flex es-gap-5 es-items-start".split(' '));
    var iconTemplate = this.dataset.icon && icons[this.dataset.icon] ? icons[this.dataset.icon]('es-min-w-[15px] es-w-[15px] es-min-h-[15px] es-h-[15px] es-text-blue-500') : '';
    this.innerHTML = "\n      ".concat(iconTemplate, "<span class=\"es-font-bold es-text-xl es-leading-none\">").concat(this.dataset.value, "</span>\n    ");
  }
}

/***/ }),

/***/ "./components/PackSelectorV2.ts":
/*!**************************************!*\
  !*** ./components/PackSelectorV2.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PackSelectorV2: () => (/* binding */ PackSelectorV2)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./utils.ts");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class PackSelectorV2 extends HTMLElement {
  constructor() {
    var _this;
    super();
    _this = this;
    _defineProperty(this, "onetimeOptions", []);
    _defineProperty(this, "membershipOptions", []);
    /**
     *
     */
    _defineProperty(this, "init", () => {
      this.innerHTML = "\n      <h2 data-header class=\"es-w-[70%] ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.m0, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.uppercase, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontGrotesk, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.text2xl, "\"></h2>\n      <div data-body class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-gap-10\">\n        <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgWhite, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p2, "\">\n          <rl-button class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex1, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " es-border-gray-200\" data-onetime-tab></rl-button>\n          <rl-button class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex1, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " es-border-gray-200\" data-membership-tab></rl-button>\n        </div>\n        <div class=\"!es-hidden es-grid es-grid-cols-2 es-gap-3\" data-onetime-content>\n        </div>\n        <div class=\"!es-hidden es-grid es-grid-cols-2 es-gap-3\" data-membership-content>\n        </div>\n      </div>\n    ");
      this.headerEl = this.querySelector('h2');
      this.onetimeTab = this.querySelector('[data-onetime-tab]');
      this.membershipTab = this.querySelector('[data-membership-tab]');
      this.onetimeContent = this.querySelector('[data-onetime-content]');
      this.membershipContent = this.querySelector('[data-membership-content]');
      this.onetimeOptions.forEach(e => this.onetimeContent.insertAdjacentElement('beforeend', e));
      this.membershipOptions.forEach(e => this.membershipContent.insertAdjacentElement('beforeend', e));
      this.onetimeTab.addEventListener('click', () => this.setActiveTab('onetime'));
      this.membershipTab.addEventListener('click', () => this.setActiveTab('membership'));
      this.setActiveTab((0,_utils__WEBPACK_IMPORTED_MODULE_1__.hasSearchParameter)('onetime') ? 'onetime' : 'membership');
    });
    /**
     *
     * @param key
     */
    _defineProperty(this, "setActiveTab", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'membership';
      _this.activeTabKey = key;
      var activeTabClasses = "es-bg-[#efbf04] hover:es-bg-[#efbf04]".split(' ');
      if (_this.activeTabKey === 'onetime') {
        var _this$onetimeTab, _this$membershipTab, _this$onetimeContent, _this$membershipConte, _this$getAttribute;
        (_this$onetimeTab = _this.onetimeTab) === null || _this$onetimeTab === void 0 || _this$onetimeTab.classList.add(...activeTabClasses);
        (_this$membershipTab = _this.membershipTab) === null || _this$membershipTab === void 0 || _this$membershipTab.classList.remove(...activeTabClasses);
        (_this$onetimeContent = _this.onetimeContent) === null || _this$onetimeContent === void 0 || _this$onetimeContent.classList.remove('!es-hidden');
        (_this$membershipConte = _this.membershipContent) === null || _this$membershipConte === void 0 || _this$membershipConte.classList.add('!es-hidden');
        if (_this.headerEl) _this.headerEl.innerHTML = (_this$getAttribute = _this.getAttribute('data-onetime-header')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : '';
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__.setSearchParameter)('onetime', 'true');
      } else {
        var _this$onetimeTab2, _this$membershipTab2, _this$onetimeContent2, _this$membershipConte2, _this$getAttribute2;
        (_this$onetimeTab2 = _this.onetimeTab) === null || _this$onetimeTab2 === void 0 || _this$onetimeTab2.classList.remove(...activeTabClasses);
        (_this$membershipTab2 = _this.membershipTab) === null || _this$membershipTab2 === void 0 || _this$membershipTab2.classList.add(...activeTabClasses);
        (_this$onetimeContent2 = _this.onetimeContent) === null || _this$onetimeContent2 === void 0 || _this$onetimeContent2.classList.add('!es-hidden');
        (_this$membershipConte2 = _this.membershipContent) === null || _this$membershipConte2 === void 0 || _this$membershipConte2.classList.remove('!es-hidden');
        if (_this.headerEl) _this.headerEl.innerHTML = (_this$getAttribute2 = _this.getAttribute('data-membership-header')) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : '';
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__.deleteSearchParameter)('onetime');
      }
      _this.dispatchEvent(new CustomEvent('onChangeTab', {
        detail: {
          key: _this.activeTabKey
        },
        bubbles: true,
        cancelable: true
      }));
    });
    this.classList.add(..."es-relative es-bg-gray-400 es-gap-10 ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-p-5 md:es-p-10 md:es-min-w-[540px] es-w-full es-max-w-[540px]").split(' '));
    this.onetimeOptions = Array.from(this.querySelectorAll('[data-onetime-option]'));
    this.membershipOptions = Array.from(this.querySelectorAll('[data-membership-option]'));
    this.init();
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-onetime-label', 'data-membership-label', 'data-prize'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _this$onetimeTab3, _this$membershipTab3;
    switch (name) {
      case 'data-onetime-label':
        return (_this$onetimeTab3 = this.onetimeTab) === null || _this$onetimeTab3 === void 0 ? void 0 : _this$onetimeTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-membership-label':
        return (_this$membershipTab3 = this.membershipTab) === null || _this$membershipTab3 === void 0 ? void 0 : _this$membershipTab3.setLabel(newValue !== null && newValue !== void 0 ? newValue : '');
      case 'data-prize':
        {
          this.insertAdjacentHTML('afterbegin', "<img class=\"es-w-[90px] es-h-[35px] md:es-w-[125px] md:es-h-[45px] es-absolute es-top-5 es-right-0\" src=\"".concat(newValue, "\" alt=\"\">"));
        }
    }
  }
}

/***/ }),

/***/ "./components/SimplePackSelector.ts":
/*!******************************************!*\
  !*** ./components/SimplePackSelector.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SimplePackSelector: () => (/* binding */ SimplePackSelector)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class SimplePackSelector extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "options", []);
    /**
     *
     */
    _defineProperty(this, "init", () => {
      var _this$options;
      this.innerHTML = "\n      <h2 data-header class=\"es-w-[70%] ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.m0, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.uppercase, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontGrotesk, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.text2xl, "\"></h2>\n      <div data-body class=\"es-grid ").concat((this === null || this === void 0 || (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length) > 1 ? 'es-grid-rows-2' : 'es-grid-rows-1', "  es-grid-cols-2 es-gap-5\">\n      </div>\n    ");
      this.headerEl = this.querySelector('h2');
      this.bodyEl = this.querySelector('[data-body]');
      this.options.forEach(e => this.bodyEl.insertAdjacentElement('beforeend', e));
    });
    this.classList.add(..."es-relative es-bg-[#F3F3F3] es-gap-10 ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " es-p-5 md:es-p-10 es-w-full es-min-w-[300px]").split(' '));
    this.options = Array.from(this.querySelectorAll('[data-option]'));
    this.init();
    this.classList.remove('es-hidden');
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-header'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-header':
        if (newValue && newValue !== null && newValue !== void 0 && newValue.length) this.headerEl.innerHTML = newValue;
    }
  }
}

/***/ }),

/***/ "./components/SimplePackSelectorNewDesign.ts":
/*!***************************************************!*\
  !*** ./components/SimplePackSelectorNewDesign.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SimplePackSelectorNewDesign: () => (/* binding */ SimplePackSelectorNewDesign)
/* harmony export */ });
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SimplePackSelectorNewDesign extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "options", []);
    /**
     *
     */
    _defineProperty(this, "init", () => {
      var _this$options;
      this.innerHTML = "\n      <div data-body class=\"es-grid ".concat((this === null || this === void 0 || (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length) > 1 ? 'es-grid-rows-2' : 'es-grid-rows-1', "  es-grid-cols-2\">\n      </div>\n    ");
      this.bodyEl = this.querySelector('[data-body]');
      this.options.forEach(e => this.bodyEl.insertAdjacentElement('beforeend', e));
    });
    this.classList.add('new-simple-pack-selector');
    this.options = Array.from(this.querySelectorAll('[data-option]'));
    this.init();
    this.classList.remove('es-hidden');
  }
}

/***/ }),

/***/ "./components/SimplePackSelectorOption.ts":
/*!************************************************!*\
  !*** ./components/SimplePackSelectorOption.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SimplePackSelectorOption: () => (/* binding */ SimplePackSelectorOption)
/* harmony export */ });
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./utils.ts");
/* harmony import */ var _services_CartApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/CartApi */ "./services/CartApi.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class SimplePackSelectorOption extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "addToCart", () => {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var propertyName = this.getAttribute('data-property-name');
      var propertyValue = this.getAttribute('data-property-value');
      var sellingPlanId = this.getAttribute('data-selling-plan-id');
      var addCartParams = _objectSpread(_objectSpread({}, sellingPlanId ? {
        selling_plan: sellingPlanId
      } : {}), !!propertyName && !!propertyValue ? {
        properties: {
          [propertyName]: propertyValue
        }
      } : {});
      this.atcButtonEl.setLoading();
      var quantity = 1;
      _services_CartApi__WEBPACK_IMPORTED_MODULE_2__["default"].addItem(+variantId, quantity, addCartParams).then(() => {
        this.dispatchEvent(new CustomEvent('onAddToCart', {
          detail: {
            sellingPlanId: sellingPlanId !== null && sellingPlanId !== void 0 && sellingPlanId.length ? +sellingPlanId : null,
            variantId: variantId !== null && variantId !== void 0 && variantId.length ? +variantId : null,
            quantity
          },
          bubbles: true,
          cancelable: true
        }));
        //TODO NEED USE EVENT ADD_TO_CART START
        try {
          var PUB_SUB_EVENTS = {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            variantChange: 'variant-change',
            cartError: 'cart-error'
          };
          if (sellingPlanId) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'Membership Upgrade', {
                'event_category': 'Membership',
                'event_label': 'Upgrade to Membership'
              });
            }
            if (typeof window.publish === 'function') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries-membership',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity,
                  'selling_plan': sellingPlanId
                }
              });
            }
          } else {
            if (typeof window.publish === 'function') {
              typeof window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity
                }
              });
            }
          }
        } catch (e) {
          console.log('[ERROR][WITH ADD TO CART] Error: ', (e === null || e === void 0 ? void 0 : e.message) || e);
        }
        //TODO NEED USE EVENT ADD_TO_CART START
        setTimeout(() => {
          var cartDrawer = document.querySelector('cart-drawer');
          var emptyInnerDrawer = document.querySelector('.drawer__inner-empty');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            cartDrawer.classList.remove('is-empty');
          }
          if (emptyInnerDrawer) {
            emptyInnerDrawer.classList.add('es-hidden');
          }
          document.dispatchEvent(new Event('cartUpdated'));
          this.atcButtonEl.setLoading(false);
        }, 500);
      }).catch(() => {
        this.atcButtonEl.setLoading(false);
      });
    });
    /**
     *
     */
    _defineProperty(this, "setAsPopular", () => {
      var badge = "<span class=\"es-block es-text-nowrap es-absolute -es-left-[5px] -es-top-[14px] sm:-es-top-[17px] ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.border, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgWhite, " es-rounded-3xl es-border-red-600 es-p-[1px]\"><span class=\"es-text-lg sm:es-text-xl es-rounded-3xl es-block es-bg-red-600 es-py-1 sm:es-py-2 es-px-5 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite, "\" data-badge>\uD83D\uDD25 Best Deal</span></span>");
      this.insertAdjacentHTML('afterbegin', badge);
      this.classList.remove(..."es-border-transparent".split(' '));
      this.classList.add(..."es-border-red-600 es-red-600-b-shadow".split(' '));
    });
    /**
     *
     */
    _defineProperty(this, "setSoldOut", () => {
      this.atcButtonEl.setDisable();
      this.atcButtonEl.setLabel('Sold out');
    });
    this.classList.add(..."es-bg-white ".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.relative, " !es-pt-8 es-p-2 md:es-p-5 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyBetween, " es-border-[4px] es-border-solid es-border-transparent es-flex-col es-pt-8").split(' '));
    this.innerHTML = "\n      <div class=\"".concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap6, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.itemsCenter, " es-w-full\" data-content>\n        <rl-wallpaper></rl-wallpaper>\n        <div class=\"es-flex es-gap-6 es-justify-between es-w-full es-flex-col es-items-center\">\n          <span data-entries class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          <span class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.gap3, "\" data-prices>\n            <span data-before-price class=\"es-strike-price empty:es-hidden ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n            <span data-price class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.fontBlack, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.italic, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.leadingNone, "\"></span>\n          </span>\n        </div>\n      </div>\n      <div class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flex, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.flexCol, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.itemsCenter, " es-gap-5 es-flex-1 es-justify-between !es-w-auto -es-mx-2 md:-es-mx-5\" data-atc>\n        <rl-button class=\"es-w-full ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.bgBlue500, " hover:es-bg-blue-700 ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.textWhite, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.justifyCenter, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_0__.classes.p5, " sm:es-max-w-[200px] md:es-max-w-[70%] es-mx-2 md:es-mx-5\" data-atc-btn data-label=\"Enter Now\"></rl-button>\n      </div>\n    ");
    this.wallpaperEl = this.querySelector('rl-wallpaper');
    this.entriesEl = this.querySelector('[data-entries]');
    this.beforePriceEl = this.querySelector('[data-before-price]');
    this.priceEl = this.querySelector('[data-price]');
    this.atcButtonEl = this.querySelector('[data-atc-btn]');
    this.atcButtonEl.addEventListener('click', this.addToCart);
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-wallpaper', 'data-before-entries', 'data-entries', 'data-price', 'data-before-price', 'data-image', 'data-popular', 'data-variant-available'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _this$getAttribute;
    switch (name) {
      case 'data-wallpaper':
        if (newValue && newValue !== null && newValue !== void 0 && newValue.length) this.wallpaperEl.setValue(+newValue);
        break;
      case 'data-entries':
        this.entriesEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<span class=\"es-flex es-flex-col es-items-center\"><span class=\"es-text-3xl md:es-text-4xl xl:es-text-5xl\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.toNumber)(+newValue), "</span> <span>Entr").concat(+newValue > 1 ? 'ies' : 'y', " </span></span>") : '';
        break;
      case 'data-price':
        this.priceEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? (0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(+newValue) + ((_this$getAttribute = this.getAttribute('data-price-suffix')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : '') : '';
        break;
      case 'data-before-price':
        this.beforePriceEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? (0,_utils__WEBPACK_IMPORTED_MODULE_1__.toMoney)(+newValue) : '';
        break;
      case 'data-popular':
        {
          var isPopular = !(newValue === 'false' || newValue === '0');
          if (isPopular) this.setAsPopular();
        }
        break;
      case 'data-variant-available':
        {
          var isAvailable = !(newValue === 'false' || newValue === '0');
          if (!isAvailable) this.setSoldOut();
        }
        break;
    }
  }
}

/***/ }),

/***/ "./components/SimplePackSelectorOptionNewDesign.ts":
/*!*********************************************************!*\
  !*** ./components/SimplePackSelectorOptionNewDesign.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SimplePackSelectorOptionNewDesign: () => (/* binding */ SimplePackSelectorOptionNewDesign)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./utils.ts");
/* harmony import */ var _services_CartApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../services/CartApi */ "./services/CartApi.ts");
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/icons */ "./components/icons/index.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class SimplePackSelectorOptionNewDesign extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "addToCart", () => {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var propertyName = this.getAttribute('data-property-name');
      var propertyValue = this.getAttribute('data-property-value');
      var sellingPlanId = this.getAttribute('data-selling-plan-id');
      var addCartParams = _objectSpread(_objectSpread({}, sellingPlanId ? {
        selling_plan: sellingPlanId
      } : {}), !!propertyName && !!propertyValue ? {
        properties: {
          [propertyName]: propertyValue
        }
      } : {});
      this.atcButtonEl.setLoading();
      var quantity = 1;
      _services_CartApi__WEBPACK_IMPORTED_MODULE_1__["default"].addItem(+variantId, quantity, addCartParams).then(() => {
        this.dispatchEvent(new CustomEvent('onAddToCart', {
          detail: {
            sellingPlanId: sellingPlanId !== null && sellingPlanId !== void 0 && sellingPlanId.length ? +sellingPlanId : null,
            variantId: variantId !== null && variantId !== void 0 && variantId.length ? +variantId : null,
            quantity
          },
          bubbles: true,
          cancelable: true
        }));
        //TODO NEED USE EVENT ADD_TO_CART START
        try {
          var PUB_SUB_EVENTS = {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            variantChange: 'variant-change',
            cartError: 'cart-error'
          };
          if (sellingPlanId) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'Membership Upgrade', {
                'event_category': 'Membership',
                'event_label': 'Upgrade to Membership'
              });
            }
            if (typeof window.publish === 'function') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries-membership',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity,
                  'selling_plan': sellingPlanId
                }
              });
            }
          } else {
            if (typeof window.publish === 'function') {
              typeof window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'entries',
                productVariantId: variantId,
                cartData: {
                  'id': variantId,
                  'quantity': quantity
                }
              });
            }
          }
        } catch (e) {
          console.log('[ERROR][WITH ADD TO CART] Error: ', (e === null || e === void 0 ? void 0 : e.message) || e);
        }
        //TODO NEED USE EVENT ADD_TO_CART START
        setTimeout(() => {
          location.href = '/checkout';
        }, 500);
      }).catch(() => {
        this.atcButtonEl.setLoading(false);
      });
    });
    /**
     *
     */
    _defineProperty(this, "setAsPopular", () => {
      this.setAttribute('is-popular-pack-option', 'true');
    });
    /**
     *
     */
    _defineProperty(this, "setSoldOut", () => {
      this.atcButtonEl.setDisable();
      this.atcButtonEl.setLabel('Sold out');
    });
    this.classList.add('new-simple-pack-selector-option');
    this.innerHTML = "\n      <div class=\"new-simple-pack-selector-option-content\" data-content>\n        <div class=\"new-simple-pack-selector-option-head\">\n          <div class=\"new-simple-pack-selector-option-entries\" data-entries></div>\n          <span data-price class=\"new-simple-pack-selector-option-price\"></span>\n        </div>\n        <div class=\"new-simple-pack-selector-option-body\">\n          <ul data-perks class=\"new-simple-pack-selector-option-perks\"></ul>\n          <rl-button class=\"new-simple-pack-selector-option-button\" data-atc-btn data-label=\"Get Started\"></rl-button>\n        </div>\n      </div>\n    ";
    this.wallpaperEl = this.querySelector('rl-wallpaper');
    this.perksEl = this.querySelector('[data-perks]');
    this.entriesEl = this.querySelector('[data-entries]');
    this.priceEl = this.querySelector('[data-price]');
    this.atcButtonEl = this.querySelector('[data-atc-btn]');
    this.atcButtonEl.addEventListener('click', this.addToCart);
    this.atcButtonEl.setIcon((0,_components_icons__WEBPACK_IMPORTED_MODULE_2__.chevronRight)('new-simple-pack-selector-option-button-icon'), 'beforeend');
  }
  /**
   *
   */
  static get observedAttributes() {
    return ['data-wallpaper', 'data-entries', 'data-price', 'data-popular', 'data-variant-available'];
  }
  /**
   *
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _this$getAttribute;
    switch (name) {
      case 'data-wallpaper':
        if (newValue && newValue !== null && newValue !== void 0 && newValue.length) {
          this.perksEl.innerHTML = "<li class=\"new-simple-pack-perk\">\n            ".concat((0,_components_icons__WEBPACK_IMPORTED_MODULE_2__.wallpaperNewIcon)('new-simple-pack-perk-icon'), "<span>+").concat(newValue, " Wallpapers</span>\n          </li>");
        }
        break;
      case 'data-entries':
        this.entriesEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<span class=\"new-simple-pack-selector-option-entries-label\">Entr".concat(+newValue > 1 ? 'ies' : 'y', " </span><span class=\"new-simple-pack-selector-option-entries-label--popular\"><span>Best Deal</span> ").concat((0,_components_icons__WEBPACK_IMPORTED_MODULE_2__.fireGradientIcon)(), "</span><span class=\"new-simple-pack-selector-option-entries-value\">").concat(this.formatEntriesNumber(+newValue), "</span><span class=\"new-simple-pack-selector-option-entries-value--popular\">").concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toNumber)(+newValue), "</span>") : '';
        break;
      case 'data-price':
        this.priceEl.innerHTML = newValue !== null && newValue !== void 0 && newValue.length ? "<span class=\"new-simple-pack-selector-option-price-value\">".concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__.toMoney)(+newValue) + ((_this$getAttribute = this.getAttribute('data-price-suffix')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : ''), "</span><span class=\"new-simple-pack-selector-option-price-label\">/month</span>") : '';
        break;
      case 'data-popular':
        {
          var isPopular = !(newValue === 'false' || newValue === '0');
          if (isPopular) this.setAsPopular();
        }
        break;
      case 'data-variant-available':
        {
          var isAvailable = !(newValue === 'false' || newValue === '0');
          if (!isAvailable) this.setSoldOut();
        }
        break;
    }
  }
  formatEntriesNumber(value) {
    value = Number(value);
    if (value < 1000) return value.toString();
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'm';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    }
  }
}

/***/ }),

/***/ "./components/SparkleStars.ts":
/*!************************************!*\
  !*** ./components/SparkleStars.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SparkleStars: () => (/* binding */ SparkleStars)
/* harmony export */ });
class SparkleStars extends HTMLElement {
  constructor() {
    var _this$dataset$sparkle;
    super();
    this.stars = JSON.parse((_this$dataset$sparkle = this.dataset.sparkleStars) !== null && _this$dataset$sparkle !== void 0 ? _this$dataset$sparkle : '[]');
    this.render();
  }
  render() {
    this.innerHTML = this.stars.map(star => {
      return this.getSparkleStarHTML(star);
    }).join('');
  }
  getSparkleStarHTML(star) {
    var cn = 'es-sparkl-star';
    var sizeCn = "".concat(cn, "-").concat(star.type);
    if (star.type === 'xl') {
      return this.getIsotoxalStar(star, sizeCn);
    }
    return "<span class=\"".concat(cn, " ").concat(sizeCn, "\" style=\"left: ").concat(star.left, "%; top: ").concat(star.top, "%\"></span>");
  }
  getIsotoxalStar(star, cn) {
    return "<div class=\"".concat(cn, "\" style=\"left: ").concat(star.left, "%; top: ").concat(star.top, "%\">\n      <div class=\"").concat(cn, "-inner\">\n        <svg width=\"58\" height=\"58\" viewBox=\"0 0 58 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <g filter=\"url(#filter0_f_3999_1762)\">\n        <circle cx=\"29.1221\" cy=\"28.9366\" r=\"8.36286\" fill=\"#1D78ED\"/>\n        </g>\n        <path d=\"M26.157 20.5286L30.1556 25.664L36.657 25.9714L31.5215 29.9701L31.2141 36.4714L27.2155 31.3359L20.7141 31.0286L25.8496 27.0299L26.157 20.5286Z\" fill=\"#1D78ED\"/>\n        <defs>\n        <filter id=\"filter0_f_3999_1762\" x=\"0.759277\" y=\"0.57373\" width=\"56.7256\" height=\"56.7258\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n        <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n        <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\n        <feGaussianBlur stdDeviation=\"10\" result=\"effect1_foregroundBlur_3999_1762\"/>\n        </filter>\n        </defs>\n        </svg>\n        ").concat(star.isShining ? this.getSparkleStarHTML({
      isShining: true,
      left: 50,
      top: 50,
      type: 'l'
    }) : '', "\n      </div>\n    </div>");
  }
}

/***/ }),

/***/ "./components/StoreCountdown.ts":
/*!**************************************!*\
  !*** ./components/StoreCountdown.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StoreCountdown: () => (/* binding */ StoreCountdown)
/* harmony export */ });
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class StoreCountdown extends HTMLElement {
  constructor() {
    var _this;
    super();
    _this = this;
    /**
     *
     */
    _defineProperty(this, "init", () => {
      this.innerHTML = this.template();
      this.start();
    });
    /**
     *
     */
    _defineProperty(this, "start", () => {
      var data = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      var tick = () => {
        var digitsTemplate = this.getDigitsTemplate();
        if (digitsTemplate !== null && digitsTemplate !== void 0 && digitsTemplate.total && digitsTemplate.total >= 0) {
          for (var key in data) data[key].innerHTML = digitsTemplate[key];
          setTimeout(tick, 1000);
        }
      };
      tick();
    });
    /**
     *
     */
    _defineProperty(this, "getDigitsTemplate", () => {
      if (!this.endDate) return;
      var total = Date.parse(this.endDate) - Date.parse((this.currentDate ? new Date(this.currentDate) : new Date()).toLocaleString('en-US', {
        timeZone: 'America/New_York'
      }));
      var convert = value => "".concat(('0' + value).slice(-2));
      var view = function view(value, label) {
        var hasColons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var t = convert(value);
        return "".concat(_this.getDigitTemplate(t, label, hasColons));
      };
      return {
        total,
        days: view(Math.floor(total / (1000 * 60 * 60 * 24)), 'Days', true),
        hours: view(Math.floor(total / (1000 * 60 * 60) % 24), 'Hours', true),
        minutes: view(Math.floor(total / 1000 / 60 % 60), 'Minutes', true),
        seconds: view(Math.floor(total / 1000 % 60), 'Seconds', true)
      };
    });
    _defineProperty(this, "template", () => {
      var _this$bodyClasses;
      return "\n      <div class=\"".concat((_this$bodyClasses = this.bodyClasses) !== null && _this$bodyClasses !== void 0 ? _this$bodyClasses : '', " es-w-full es-px-5 es-py-6 md:es-py-12\"> \n        <div class=\"es-flex es-flex-col es-gap-3 md:es-gap-6 es-justify-center es-items-center\">\n          ").concat(this.heading ? "<h3 class=\"es-m-0 es-font-figtree es-text-lg md:es-text-4xl es-font-black es-text-center es-uppercase es-w-full es-glowing-text-100 es-text-white\">".concat(this.heading, "</h3>") : '', "\n          <div class=\"es-flex es-justify-center es-items-center es-gap-3 md:es-gap-6\">\n            ").concat(['Days', 'Hours', 'Minutes', 'Seconds'].map((label, index, labels) => this.getDigitTemplate('00', label, false, labels.length - 1 !== index)).join(''), "\n          </div>\n        </div>\n      </div>");
    });
    /**
     *
     * @param value
     */
    _defineProperty(this, "getDigitTemplate", function (value, label) {
      var _this$dotsClasses, _this$dotsWrapperClas, _this$digitsClasses, _this$labelsClasses;
      var skipColons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var hasColons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var dot = "<span class=\"es-flex es-justify-center es-items-center es-w-[7px] md:es-w-[14px] es-h-[7px] md:es-h-[14px] es-rounded-full\"><span class=\"".concat((_this$dotsClasses = _this.dotsClasses) !== null && _this$dotsClasses !== void 0 ? _this$dotsClasses : '', " es-w-[5px] md:es-w-[10px] es-h-[5px] md:es-h-[10px] es-rounded-full es-bg-white\"></span></span>");
      var colons = skipColons ? '' : hasColons ? "<div class=\"".concat((_this$dotsWrapperClas = _this.dotsWrapperClasses) !== null && _this$dotsWrapperClas !== void 0 ? _this$dotsWrapperClas : '', " es-pt-3 md:es-pt-9 es-flex es-flex-col es-gap-1 md:es-gap-2 es-self-stretch\">\n    ").concat([dot, dot].join(''), "\n</div>") : '';
      return "\n        <div data-".concat(label.toLowerCase(), " class=\"es-flex es-flex-col es-items-center es-gap-1 md:es-gap-2 es-text-white\">\n            <span class=\"").concat((_this$digitsClasses = _this.digitsClasses) !== null && _this$digitsClasses !== void 0 ? _this$digitsClasses : '', " es-relative es-font-montserrat es-text-5xl sm:es-text-7xl md:es-text-8xl xl:es-text-9xl es-font-black es-leading-none\">").concat(value, "</span>\n            <span class=\"").concat((_this$labelsClasses = _this.labelsClasses) !== null && _this$labelsClasses !== void 0 ? _this$labelsClasses : '', " es-font-figtree es-text-2xl sm:es-text-3xl md::es-text-4xl xl:es-text-5xl es-font-semibold es-leading-6 md:es-leading-9\">").concat(label, "</span>\n        </div>\n        ").concat(colons, "\n        ");
    });
  }
  connectedCallback() {
    if (!this.endDate) {
      this.remove();
      return;
    }
    this.init();
  }
  static get observedAttributes() {
    return ['data-current-date', 'data-end-date', 'data-countdown-heading', 'data-digits-classes', 'data-labels-classes', 'data-dots-classes', 'data-dots-wrapper-classes', 'data-body-classes'];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-countdown-heading' && newValue) {
      this.heading = this.getAttribute('data-countdown-heading');
    }
    if (name === 'data-end-date' && newValue) {
      this.endDate = this.getAttribute('data-end-date');
    }
    if (name === 'data-current-date' && newValue) {
      this.currentDate = this.getAttribute('data-current-date');
    }
    if (name === 'data-digits-classes' && newValue) {
      this.digitsClasses = this.getAttribute('data-digits-classes');
    }
    if (name === 'data-labels-classes' && newValue) {
      this.labelsClasses = this.getAttribute('data-labels-classes');
    }
    if (name === 'data-dots-classes' && newValue) {
      this.dotsClasses = this.getAttribute('data-dots-classes');
    }
    if (name === 'data-dots-wrapper-classes' && newValue) {
      this.dotsWrapperClasses = this.getAttribute('data-dots-wrapper-classes');
    }
    if (name === 'data-body-classes' && newValue) {
      this.bodyClasses = this.getAttribute('data-body-classes');
    }
    this.init();
  }
}

/***/ }),

/***/ "./components/Wallpaper.ts":
/*!*********************************!*\
  !*** ./components/Wallpaper.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Wallpaper: () => (/* binding */ Wallpaper)
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Button */ "./components/Button.ts");
/* harmony import */ var tippy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! tippy.js */ "./node_modules/tippy.js/dist/tippy.esm.js");
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./classes */ "./components/classes.ts");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class Wallpaper extends _Button__WEBPACK_IMPORTED_MODULE_0__.Button {
  constructor() {
    super();
    _defineProperty(this, "setValue", value => {
      this.setLabel("\uD83C\uDF81 +".concat(value, " wallpaper").concat(value > 1 ? 's' : ''));
    });
    this.classList.add(...'es-border es-border-solid es-border-blue-500 es-rounded-3xl es-py-1 es-px-3 sm:es-px-6 es-text-lg sm:es-text-xl es-bg-blue-100'.split(' '));
    (0,tippy_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this, {
      theme: 'light',
      arrow: tippy_js__WEBPACK_IMPORTED_MODULE_2__.roundArrow,
      content: "<div class=\"".concat(_classes__WEBPACK_IMPORTED_MODULE_1__.classes.bgWhite, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_1__.classes.p5, " ").concat(_classes__WEBPACK_IMPORTED_MODULE_1__.classes.textBlack, "\">\n        <strong class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_1__.classes.uppercase, "\">Free Digital Wallpapers</strong>\n        <p>Enjoy a free digital wallpaper with every digital entry or membership. Show off your favorite Redline Society giveaway car! Download as many times as you want.</p>\n        <p><strong>Questions?</strong> Contact <a class=\"").concat(_classes__WEBPACK_IMPORTED_MODULE_1__.classes.textBlack, "\" href=\"mailto:support@redlinesociety.com\">support@redlinesociety.com</a></p>\n        <p><strong>Or write to:</strong> Redline Society 35246 US HWY 19 N Ste.175 Palm Harbor, FL 34684.</p>\n      </div>"),
      allowHTML: true
    });
  }
}

/***/ }),

/***/ "./components/classes.ts":
/*!*******************************!*\
  !*** ./components/classes.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   classes: () => (/* binding */ classes)
/* harmony export */ });
var classes = {
  //TEXT
  fontGrotesk: 'es-font-grotesk',
  fontBlack: 'es-font-black',
  uppercase: 'es-uppercase',
  italic: 'es-italic',
  text2xl: 'es-text-2xl',
  textBlack: 'es-text-black',
  textWhite: 'es-text-white',
  flex: 'es-flex',
  flexCol: 'es-flex-col',
  justifyCenter: 'es-justify-center',
  justifyBetween: 'es-justify-between',
  flex1: 'es-flex-1',
  itemsStart: 'es-items-start',
  itemsCenter: 'es-items-center',
  itemsEnd: 'es-items-end',
  hidden: 'es-hidden',
  leadingNone: 'es-leading-none',
  bgWhite: 'es-bg-white',
  bgBlue500: 'es-bg-blue-500',
  relative: 'es-relative',
  absolute: 'es-absolute',
  gap1: 'es-gap-1',
  gap2: 'es-gap-2',
  gap3: 'es-gap-3',
  gap5: 'es-gap-5',
  gap6: 'es-gap-6',
  gap10: 'es-gap-10',
  border: 'es-border es-border-solid',
  cursorPointer: 'es-cursor-pointer',
  wFull: 'es-w-full',
  m0: 'es-m-0',
  p2: 'es-p-2',
  p5: 'es-p-5',
  p10: 'es-p-10'
};

/***/ }),

/***/ "./components/icons/index.ts":
/*!***********************************!*\
  !*** ./components/icons/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   chevronRight: () => (/* binding */ chevronRight),
/* harmony export */   circlePercentIcon: () => (/* binding */ circlePercentIcon),
/* harmony export */   discountIcon: () => (/* binding */ discountIcon),
/* harmony export */   doublePrizeIcon: () => (/* binding */ doublePrizeIcon),
/* harmony export */   fireBlueIcon: () => (/* binding */ fireBlueIcon),
/* harmony export */   fireGradientIcon: () => (/* binding */ fireGradientIcon),
/* harmony export */   membersGiveawayIcon: () => (/* binding */ membersGiveawayIcon),
/* harmony export */   prizeIcon: () => (/* binding */ prizeIcon),
/* harmony export */   prizeNewIcon: () => (/* binding */ prizeNewIcon),
/* harmony export */   wallpaperNewIcon: () => (/* binding */ wallpaperNewIcon)
/* harmony export */ });
var circlePercentIcon = function circlePercentIcon() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "<svg class=\"".concat(classes, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" fill=\"none\">\n  <path d=\"M6 0C9.3138 0 12 2.6862 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6L0.00239997 5.832C0.0912 2.5962 2.742 0 6 0ZM7.8 7.272C7.64087 7.272 7.48826 7.33521 7.37574 7.44774C7.26321 7.56026 7.2 7.71287 7.2 7.872V7.881C7.2 8.04013 7.26321 8.19274 7.37574 8.30526C7.48826 8.41779 7.64087 8.481 7.8 8.481C7.95913 8.481 8.11174 8.41779 8.22426 8.30526C8.33679 8.19274 8.4 8.04013 8.4 7.881V7.872C8.4 7.71287 8.33679 7.56026 8.22426 7.44774C8.11174 7.33521 7.95913 7.272 7.8 7.272ZM8.2242 3.8208C8.11168 3.70832 7.9591 3.64513 7.8 3.64513C7.6409 3.64513 7.48832 3.70832 7.3758 3.8208L3.7758 7.4208C3.66651 7.53396 3.60603 7.68552 3.6074 7.84284C3.60876 8.00016 3.67186 8.15065 3.78311 8.26189C3.89435 8.37314 4.04484 8.43624 4.20216 8.4376C4.35948 8.43897 4.51104 8.3785 4.6242 8.2692L8.2242 4.6692C8.33668 4.55668 8.39987 4.4041 8.39987 4.245C8.39987 4.0859 8.33668 3.93332 8.2242 3.8208ZM4.2 3.663C4.04087 3.663 3.88826 3.72621 3.77574 3.83874C3.66321 3.95126 3.6 4.10387 3.6 4.263V4.272C3.6 4.43113 3.66321 4.58374 3.77574 4.69626C3.88826 4.80879 4.04087 4.872 4.2 4.872C4.35913 4.872 4.51174 4.80879 4.62426 4.69626C4.73679 4.58374 4.8 4.43113 4.8 4.272V4.263C4.8 4.10387 4.73679 3.95126 4.62426 3.83874C4.51174 3.72621 4.35913 3.663 4.2 3.663Z\" fill=\"currentColor\"/>\n</svg>");
};
var prizeIcon = function prizeIcon() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "<svg class=\"".concat(classes, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11\" fill=\"none\">\n  <path d=\"M4.39636 2.23702e-05C3.36545 -0.00543218 2.36182 0.987295 2.82 2.22002H1.09091C0.801582 2.22002 0.524105 2.33496 0.31952 2.53954C0.114935 2.74413 0 3.0216 0 3.31093V4.40184C0 4.5465 0.0574673 4.68524 0.15976 4.78754C0.262052 4.88983 0.400791 4.9473 0.545455 4.9473H5.45455V3.31093H6.54545V4.9473H11.4545C11.5992 4.9473 11.7379 4.88983 11.8402 4.78754C11.9425 4.68524 12 4.5465 12 4.40184V3.31093C12 3.0216 11.8851 2.74413 11.6805 2.53954C11.4759 2.33496 11.1984 2.22002 10.9091 2.22002H9.18C9.81818 0.436386 7.41818 -0.823614 6.31091 0.714568L6 1.12911L5.68909 0.703659C5.34545 0.218204 4.87091 0.00547692 4.39636 2.23702e-05ZM4.36364 1.12911C4.84909 1.12911 5.09454 1.7182 4.75091 2.06184C4.40727 2.40548 3.81818 2.16002 3.81818 1.67457C3.81818 1.5299 3.87565 1.39117 3.97794 1.28887C4.08023 1.18658 4.21897 1.12911 4.36364 1.12911ZM7.63636 1.12911C8.12182 1.12911 8.36727 1.7182 8.02364 2.06184C7.68 2.40548 7.09091 2.16002 7.09091 1.67457C7.09091 1.5299 7.14838 1.39117 7.25067 1.28887C7.35296 1.18658 7.4917 1.12911 7.63636 1.12911ZM0.545455 5.49275V9.85639C0.545455 10.1457 0.660389 10.4232 0.864974 10.6278C1.06956 10.8324 1.34704 10.9473 1.63636 10.9473H10.3636C10.653 10.9473 10.9304 10.8324 11.135 10.6278C11.3396 10.4232 11.4545 10.1457 11.4545 9.85639V5.49275H6.54545V9.85639H5.45455V5.49275H0.545455Z\" fill=\"currentColor\"/>\n</svg>");
};
var doublePrizeIcon = function doublePrizeIcon() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "<svg class=\"".concat(classes, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" fill=\"none\">\n  <path d=\"M4.51137 3.69565C4.547 3.10913 4.83575 2.53022 5.33637 2.17602C5.23887 1.97036 5.03825 1.82754 4.80012 1.82754H4.24887L4.8245 1.40859C4.9595 1.31147 4.99137 1.12104 4.89387 0.983932L4.7195 0.736373C4.62387 0.599264 4.43637 0.566891 4.30137 0.665914L3.70137 1.102L3.917 0.519283C3.97512 0.361227 3.89637 0.186032 3.74075 0.126998L3.4595 0.0203577C3.30387 -0.0386755 3.13137 0.041305 3.07325 0.199362L2.70012 1.20864L2.327 0.197457C2.26887 0.0394007 2.09637 -0.0405798 1.94075 0.0184534L1.6595 0.125094C1.50387 0.184127 1.42512 0.361227 1.48512 0.517379L1.70075 1.10009L1.09887 0.665914C0.963872 0.568795 0.776372 0.599264 0.680747 0.736373L0.506372 0.983932C0.410747 1.12104 0.440747 1.31147 0.575747 1.40859L1.15137 1.82754H0.600122C0.268247 1.82754 0.00012207 2.09985 0.00012207 2.43691V9.14003C0.00012207 9.4771 0.268247 9.74941 0.600122 9.74941H3.767C3.66387 9.5685 3.60012 9.36284 3.60012 9.14003V4.87441C3.60012 4.30503 3.99012 3.82705 4.51137 3.69565ZM4.20012 9.14003C4.20012 9.4771 4.46825 9.74941 4.80012 9.74941H7.80012V7.31191H4.20012V9.14003ZM8.40012 9.74941H11.4001C11.732 9.74941 12.0001 9.4771 12.0001 9.14003V7.31191H8.40012V9.74941ZM11.4001 4.26504H11.0176C11.0664 4.12031 11.1001 3.96987 11.1001 3.81181C11.1001 3.13579 10.5939 2.43691 9.74825 2.43691C8.84637 2.43691 8.32512 3.34526 8.10012 3.87085C7.87325 3.34526 7.352 2.43691 6.452 2.43691C5.60637 2.43691 5.10012 3.13579 5.10012 3.81181C5.10012 3.96987 5.132 4.12031 5.18262 4.26504H4.80012C4.46825 4.26504 4.20012 4.53735 4.20012 4.87441V6.70253H7.80012V4.26504H8.087L8.10012 4.26123L8.11325 4.26504H8.40012V6.70253H12.0001V4.87441C12.0001 4.53735 11.732 4.26504 11.4001 4.26504ZM6.30012 4.26504C6.2495 4.23838 6.2045 4.20791 6.16512 4.17363C6.02825 4.05175 6.00012 3.91084 6.00012 3.81181C6.00012 3.6271 6.12012 3.35097 6.452 3.35097C6.80262 3.35097 7.1195 3.87275 7.28637 4.26504H6.30012ZM10.0351 4.17363C9.99575 4.20791 9.95075 4.23838 9.90012 4.26504H8.91387C9.07887 3.87846 9.39762 3.35097 9.74825 3.35097C10.0801 3.35097 10.2001 3.6271 10.2001 3.81181C10.2001 3.91084 10.172 4.05175 10.0351 4.17363Z\" fill=\"currentColor\"/>\n</svg>");
};
var wallpaperNewIcon = function wallpaperNewIcon() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "<svg class=\"".concat(classes, "\"  viewBox=\"0 0 21 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M4.2832 22H15.9768\" stroke=\"#7D8A93\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M16.2035 13.73C16.0093 13.498 15.7787 13.3141 15.525 13.1888C15.2713 13.0636 14.9995 12.9994 14.7251 13H5.53735C4.98354 13 4.45242 13.2634 4.06082 13.7322C3.66922 14.2011 3.44922 14.837 3.44922 15.5V17C3.44922 17.2652 3.53722 17.5196 3.69386 17.7071C3.8505 17.8946 4.06295 18 4.28447 18H15.978C16.1995 18 16.412 17.8946 16.5686 17.7071C16.7253 17.5196 16.8133 17.2652 16.8133 17V15.5C16.8133 14.84 16.5961 14.2 16.2035 13.73Z\" stroke=\"#7D8A93\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M11.8013 13V8.5C11.8013 7 12.6365 7 12.6365 5C12.6365 4.20435 12.3725 3.44129 11.9026 2.87868C11.4327 2.31607 10.7953 2 10.1308 2C8.74424 2 7.625 3 7.625 5C7.625 7 8.46025 7 8.46025 8.5V13\" stroke=\"#7D8A93\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n");
};
var prizeNewIcon = function prizeNewIcon() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "<svg class=\"".concat(classes, "\" viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M15.8333 6.33325H3.16667C2.72944 6.33325 2.375 6.68769 2.375 7.12492V8.70825C2.375 9.14548 2.72944 9.49992 3.16667 9.49992H15.8333C16.2706 9.49992 16.625 9.14548 16.625 8.70825V7.12492C16.625 6.68769 16.2706 6.33325 15.8333 6.33325Z\" stroke=\"#7D8A93\" stroke-width=\"1.58333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M9.5 6.33325V16.6249\" stroke=\"#7D8A93\" stroke-width=\"1.58333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M15.0423 9.5V15.0417C15.0423 15.4616 14.8755 15.8643 14.5786 16.1613C14.2816 16.4582 13.8789 16.625 13.459 16.625H5.54232C5.12239 16.625 4.71966 16.4582 4.42273 16.1613C4.1258 15.8643 3.95898 15.4616 3.95898 15.0417V9.5\" stroke=\"#7D8A93\" stroke-width=\"1.58333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M5.93815 6.33344C5.41324 6.33344 4.90983 6.12492 4.53867 5.75375C4.1675 5.38258 3.95898 4.87918 3.95898 4.35427C3.95898 3.82936 4.1675 3.32595 4.53867 2.95479C4.90983 2.58362 5.41324 2.3751 5.93815 2.3751C6.70186 2.3618 7.45025 2.73235 8.08573 3.43844C8.72121 4.14453 9.21429 5.15338 9.50065 6.33344C9.78702 5.15338 10.2801 4.14453 10.9156 3.43844C11.551 2.73235 12.2994 2.3618 13.0632 2.3751C13.5881 2.3751 14.0915 2.58362 14.4626 2.95479C14.8338 3.32595 15.0423 3.82936 15.0423 4.35427C15.0423 4.87918 14.8338 5.38258 14.4626 5.75375C14.0915 6.12492 13.5881 6.33344 13.0632 6.33344\" stroke=\"#7D8A93\" stroke-width=\"1.58333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n");
};
var membersGiveawayIcon = function membersGiveawayIcon() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "<svg class=\"".concat(classes, "\" viewBox=\"0 0 17 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.66602 10.4167C8.01323 10.4167 9.91602 8.51396 9.91602 6.16675C9.91602 3.81954 8.01323 1.91675 5.66602 1.91675C3.31881 1.91675 1.41602 3.81954 1.41602 6.16675C1.41602 8.51396 3.31881 10.4167 5.66602 10.4167Z\" stroke=\"#7D8A93\" stroke-width=\"1.41667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M12.8136 7.84546C13.4832 8.0951 14.079 8.50954 14.546 9.05047C15.0129 9.59141 15.336 10.2414 15.4852 10.9402C15.6344 11.6391 15.605 12.3643 15.3997 13.0488C15.1944 13.7333 14.8198 14.3549 14.3106 14.8563C13.8013 15.3576 13.1739 15.7225 12.4863 15.9171C11.7987 16.1117 11.0731 16.1298 10.3767 15.9697C9.68022 15.8095 9.03539 15.4764 8.50181 15.001C7.96823 14.5257 7.56313 13.9235 7.32397 13.25\" stroke=\"#7D8A93\" stroke-width=\"1.41667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M4.95898 4.75H5.66732V7.58333\" stroke=\"#7D8A93\" stroke-width=\"1.41667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M11.8357 10.3315L12.3315 10.8345L10.334 12.832\" stroke=\"#7D8A93\" stroke-width=\"1.41667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n");
};
var chevronRight = function chevronRight() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "<svg class=\"".concat(classes, "\" width=\"8\" height=\"19\" viewBox=\"0 0 8 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_2_158)\">\n<path d=\"M1.98438 14.3717L6.68708 9.66901L1.98438 4.96631\" stroke=\"white\" stroke-width=\"1.56757\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_2_158\">\n<rect width=\"7.05405\" height=\"18.8108\" fill=\"white\" transform=\"translate(0.605469 0.0944824)\"/>\n</clipPath>\n</defs>\n</svg>\n");
};
var fireBlueIcon = () => "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.5 14.5C9.16304 14.5 9.79893 14.2366 10.2678 13.7678C10.7366 13.2989 11 12.663 11 12C11 10.62 10.5 10 10 9C8.928 6.857 9.776 4.946 12 3C12.5 5.5 14 7.9 16 9.5C18 11.1 19 13 19 15C19 15.9193 18.8189 16.8295 18.4672 17.6788C18.1154 18.5281 17.5998 19.2997 16.9497 19.9497C16.2997 20.5998 15.5281 21.1154 14.6788 21.4672C13.8295 21.8189 12.9193 22 12 22C11.0807 22 10.1705 21.8189 9.32122 21.4672C8.47194 21.1154 7.70026 20.5998 7.05025 19.9497C6.40024 19.2997 5.88463 18.5281 5.53284 17.6788C5.18106 16.8295 5 15.9193 5 15C5 13.847 5.433 12.706 6 12C6 12.663 6.26339 13.2989 6.73223 13.7678C7.20107 14.2366 7.83696 14.5 8.5 14.5Z\" stroke=\"#0A7AEB\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n";
var fireGradientIcon = () => "<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.73242 14.5C9.39546 14.5 10.0313 14.2366 10.5002 13.7678C10.969 13.2989 11.2324 12.663 11.2324 12C11.2324 10.62 10.7324 10 10.2324 9C9.16042 6.857 10.0084 4.946 12.2324 3C12.7324 5.5 14.2324 7.9 16.2324 9.5C18.2324 11.1 19.2324 13 19.2324 15C19.2324 15.9193 19.0514 16.8295 18.6996 17.6788C18.3478 18.5281 17.8322 19.2997 17.1822 19.9497C16.5322 20.5998 15.7605 21.1154 14.9112 21.4672C14.0619 21.8189 13.1517 22 12.2324 22C11.3132 22 10.4029 21.8189 9.55364 21.4672C8.70436 21.1154 7.93268 20.5998 7.28267 19.9497C6.63266 19.2997 6.11705 18.5281 5.76526 17.6788C5.41348 16.8295 5.23242 15.9193 5.23242 15C5.23242 13.847 5.66542 12.706 6.23242 12C6.23242 12.663 6.49581 13.2989 6.96465 13.7678C7.4335 14.2366 8.06938 14.5 8.73242 14.5Z\" stroke=\"url(#paint0_linear_9_118)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<defs>\n<linearGradient id=\"paint0_linear_9_118\" x1=\"10.5961\" y1=\"6.51852\" x2=\"18.7555\" y2=\"11.6718\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#F90100\"/>\n<stop offset=\"1\" stop-color=\"#FFAA00\"/>\n</linearGradient>\n</defs>\n</svg>";
var discountIcon = () => "<svg width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.4\" clip-path=\"url(#clip0_2_312)\">\n<path d=\"M6.4987 11.9168C9.49024 11.9168 11.9154 9.4917 11.9154 6.50016C11.9154 3.50862 9.49024 1.0835 6.4987 1.0835C3.50716 1.0835 1.08203 3.50862 1.08203 6.50016C1.08203 9.4917 3.50716 11.9168 6.4987 11.9168Z\" stroke=\"#232529\" stroke-width=\"1.08333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M6.5 8.66667V6.5\" stroke=\"#232529\" stroke-width=\"1.08333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M6.5 4.3335H6.50583\" stroke=\"#232529\" stroke-width=\"1.08333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_2_312\">\n<rect width=\"13\" height=\"13\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n";

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/createPopper.js":
/*!*********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/createPopper.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createPopper: () => (/* binding */ createPopper),
/* harmony export */   detectOverflow: () => (/* reexport safe */ _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   popperGenerator: () => (/* binding */ popperGenerator)
/* harmony export */ });
/* harmony import */ var _dom_utils_getCompositeRect_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./dom-utils/getCompositeRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js");
/* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dom-utils/getLayoutRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js");
/* harmony import */ var _dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./dom-utils/listScrollParents.js */ "./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js");
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js");
/* harmony import */ var _utils_orderModifiers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/orderModifiers.js */ "./node_modules/@popperjs/core/lib/utils/orderModifiers.js");
/* harmony import */ var _utils_debounce_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils/debounce.js */ "./node_modules/@popperjs/core/lib/utils/debounce.js");
/* harmony import */ var _utils_mergeByName_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/mergeByName.js */ "./node_modules/@popperjs/core/lib/utils/mergeByName.js");
/* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js");
/* harmony import */ var _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dom-utils/instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: (0,_dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isElement)(reference) ? (0,_dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__["default"])(reference) : reference.contextElement ? (0,_dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__["default"])(reference.contextElement) : [],
          popper: (0,_dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__["default"])(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = (0,_utils_orderModifiers_js__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_utils_mergeByName_js__WEBPACK_IMPORTED_MODULE_3__["default"])([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: (0,_dom_utils_getCompositeRect_js__WEBPACK_IMPORTED_MODULE_4__["default"])(reference, (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_5__["default"])(popper), state.options.strategy === 'fixed'),
          popper: (0,_dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_6__["default"])(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: (0,_utils_debounce_js__WEBPACK_IMPORTED_MODULE_7__["default"])(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/contains.js":
/*!***************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/contains.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ contains)
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isShadowRoot)(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js":
/*!****************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getBoundingClientRect)
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js");
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");
/* harmony import */ var _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./isLayoutViewport.js */ "./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js");




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(element)) {
    scaleX = element.offsetWidth > 0 ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__.round)(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__.round)(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isElement)(element) ? (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_2__["default"])(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !(0,_isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__["default"])() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getClippingRect)
/* harmony export */ });
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
/* harmony import */ var _getViewportRect_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getViewportRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js");
/* harmony import */ var _getDocumentRect_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./getDocumentRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js");
/* harmony import */ var _listScrollParents_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./listScrollParents.js */ "./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js");
/* harmony import */ var _getOffsetParent_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js");
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js");
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js");
/* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js");
/* harmony import */ var _contains_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./contains.js */ "./node_modules/@popperjs/core/lib/dom-utils/contains.js");
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js");
/* harmony import */ var _utils_rectToClientRect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/rectToClientRect.js */ "./node_modules/@popperjs/core/lib/utils/rectToClientRect.js");
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js");















function getInnerBoundingClientRect(element, strategy) {
  var rect = (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === _enums_js__WEBPACK_IMPORTED_MODULE_1__.viewport ? (0,_utils_rectToClientRect_js__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_getViewportRect_js__WEBPACK_IMPORTED_MODULE_3__["default"])(element, strategy)) : (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0,_utils_rectToClientRect_js__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_getDocumentRect_js__WEBPACK_IMPORTED_MODULE_5__["default"])((0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_6__["default"])(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = (0,_listScrollParents_js__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_getParentNode_js__WEBPACK_IMPORTED_MODULE_8__["default"])(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf((0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_9__["default"])(element).position) >= 0;
  var clipperElement = canEscapeClipping && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isHTMLElement)(element) ? (0,_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_10__["default"])(element) : element;

  if (!(0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(clippingParent) && (0,_contains_js__WEBPACK_IMPORTED_MODULE_11__["default"])(clippingParent, clipperElement) && (0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_12__["default"])(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_13__.max)(rect.top, accRect.top);
    accRect.right = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_13__.min)(rect.right, accRect.right);
    accRect.bottom = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_13__.min)(rect.bottom, accRect.bottom);
    accRect.left = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_13__.max)(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getCompositeRect)
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js");
/* harmony import */ var _getNodeScroll_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./getNodeScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js");
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js");
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");
/* harmony import */ var _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./getWindowScrollBarX.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js");
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _isScrollParent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./isScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js");
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js");









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(rect.width) / element.offsetWidth || 1;
  var scaleY = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(offsetParent);
  var offsetParentIsScaled = (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
  var documentElement = (0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(offsetParent);
  var rect = (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_3__["default"])(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    (0,_isScrollParent_js__WEBPACK_IMPORTED_MODULE_5__["default"])(documentElement)) {
      scroll = (0,_getNodeScroll_js__WEBPACK_IMPORTED_MODULE_6__["default"])(offsetParent);
    }

    if ((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(offsetParent)) {
      offsets = (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_3__["default"])(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = (0,_getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_7__["default"])(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getComputedStyle)
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");

function getComputedStyle(element) {
  return (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element).getComputedStyle(element);
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js":
/*!*************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getDocumentElement)
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return (((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isElement)(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getDocumentRect)
/* harmony export */ });
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js");
/* harmony import */ var _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getWindowScrollBarX.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js");
/* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getWindowScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js");
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js");




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = (0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element);
  var winScroll = (0,_getWindowScroll_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_2__.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_2__.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + (0,_getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__["default"])(element);
  var y = -winScroll.scrollTop;

  if ((0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_4__["default"])(body || html).direction === 'rtl') {
    x += (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_2__.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getHTMLElementScroll)
/* harmony export */ });
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js":
/*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getLayoutRect)
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js");
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js":
/*!******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getNodeName)
/* harmony export */ });
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js":
/*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getNodeScroll)
/* harmony export */ });
/* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getWindowScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js");
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");
/* harmony import */ var _getHTMLElementScroll_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getHTMLElementScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js");




function getNodeScroll(node) {
  if (node === (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node) || !(0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(node)) {
    return (0,_getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__["default"])(node);
  } else {
    return (0,_getHTMLElementScroll_js__WEBPACK_IMPORTED_MODULE_3__["default"])(node);
  }
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getOffsetParent)
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js");
/* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js");
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");
/* harmony import */ var _isTableElement_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./isTableElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js");
/* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js");
/* harmony import */ var _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/userAgent.js */ "./node_modules/@popperjs/core/lib/utils/userAgent.js");








function getTrueOffsetParent(element) {
  if (!(0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
  (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test((0,_utils_userAgent_js__WEBPACK_IMPORTED_MODULE_2__["default"])());
  var isIE = /Trident/i.test((0,_utils_userAgent_js__WEBPACK_IMPORTED_MODULE_2__["default"])());

  if (isIE && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = (0,_getParentNode_js__WEBPACK_IMPORTED_MODULE_3__["default"])(element);

  if ((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isShadowRoot)(currentNode)) {
    currentNode = currentNode.host;
  }

  while ((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(currentNode) && ['html', 'body'].indexOf((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(currentNode)) < 0) {
    var css = (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_5__["default"])(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && (0,_isTableElement_js__WEBPACK_IMPORTED_MODULE_6__["default"])(offsetParent) && (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && ((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(offsetParent) === 'html' || (0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(offsetParent) === 'body' && (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js":
/*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getParentNode)
/* harmony export */ });
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js");
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");



function getParentNode(element) {
  if ((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(element) // fallback

  );
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getScrollParent)
/* harmony export */ });
/* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js");
/* harmony import */ var _isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./isScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js");
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js");
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if ((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(node) && (0,_isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__["default"])(node)) {
    return node;
  }

  return getScrollParent((0,_getParentNode_js__WEBPACK_IMPORTED_MODULE_3__["default"])(node));
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getViewportRect)
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getWindowScrollBarX.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js");
/* harmony import */ var _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./isLayoutViewport.js */ "./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js");




function getViewportRect(element, strategy) {
  var win = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element);
  var html = (0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = (0,_isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_2__["default"])();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + (0,_getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__["default"])(element),
    y: y
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js":
/*!****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getWindow)
/* harmony export */ });
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getWindowScroll)
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");

function getWindowScroll(node) {
  var win = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getWindowScrollBarX)
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js");
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getWindowScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js");



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element)).left + (0,_getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__["default"])(element).scrollLeft;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   isElement: () => (/* binding */ isElement),
/* harmony export */   isHTMLElement: () => (/* binding */ isHTMLElement),
/* harmony export */   isShadowRoot: () => (/* binding */ isShadowRoot)
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");


function isElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isLayoutViewport)
/* harmony export */ });
/* harmony import */ var _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/userAgent.js */ "./node_modules/@popperjs/core/lib/utils/userAgent.js");

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test((0,_utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__["default"])());
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isScrollParent)
/* harmony export */ });
/* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js");

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isTableElement)
/* harmony export */ });
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js");

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element)) >= 0;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js":
/*!************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ listScrollParents)
/* harmony export */ });
/* harmony import */ var _getScrollParent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js");
/* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js");
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");
/* harmony import */ var _isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./isScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js");




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = (0,_getScrollParent_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_1__["default"])(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], (0,_isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__["default"])(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents((0,_getParentNode_js__WEBPACK_IMPORTED_MODULE_3__["default"])(target)));
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/enums.js":
/*!**************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/enums.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   afterMain: () => (/* binding */ afterMain),
/* harmony export */   afterRead: () => (/* binding */ afterRead),
/* harmony export */   afterWrite: () => (/* binding */ afterWrite),
/* harmony export */   auto: () => (/* binding */ auto),
/* harmony export */   basePlacements: () => (/* binding */ basePlacements),
/* harmony export */   beforeMain: () => (/* binding */ beforeMain),
/* harmony export */   beforeRead: () => (/* binding */ beforeRead),
/* harmony export */   beforeWrite: () => (/* binding */ beforeWrite),
/* harmony export */   bottom: () => (/* binding */ bottom),
/* harmony export */   clippingParents: () => (/* binding */ clippingParents),
/* harmony export */   end: () => (/* binding */ end),
/* harmony export */   left: () => (/* binding */ left),
/* harmony export */   main: () => (/* binding */ main),
/* harmony export */   modifierPhases: () => (/* binding */ modifierPhases),
/* harmony export */   placements: () => (/* binding */ placements),
/* harmony export */   popper: () => (/* binding */ popper),
/* harmony export */   read: () => (/* binding */ read),
/* harmony export */   reference: () => (/* binding */ reference),
/* harmony export */   right: () => (/* binding */ right),
/* harmony export */   start: () => (/* binding */ start),
/* harmony export */   top: () => (/* binding */ top),
/* harmony export */   variationPlacements: () => (/* binding */ variationPlacements),
/* harmony export */   viewport: () => (/* binding */ viewport),
/* harmony export */   write: () => (/* binding */ write)
/* harmony export */ });
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js":
/*!******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _dom_utils_getNodeName_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../dom-utils/getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js");
/* harmony import */ var _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../dom-utils/instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!(0,_dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(element) || !(0,_dom_utils_getNodeName_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!(0,_dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(element) || !(0,_dom_utils_getNodeName_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/arrow.js":
/*!************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/arrow.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js");
/* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../dom-utils/getLayoutRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js");
/* harmony import */ var _dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../dom-utils/contains.js */ "./node_modules/@popperjs/core/lib/dom-utils/contains.js");
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js");
/* harmony import */ var _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/getMainAxisFromPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js");
/* harmony import */ var _utils_within_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/within.js */ "./node_modules/@popperjs/core/lib/utils/within.js");
/* harmony import */ var _utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/mergePaddingObject.js */ "./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js");
/* harmony import */ var _utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/expandToHashMap.js */ "./node_modules/@popperjs/core/lib/utils/expandToHashMap.js");
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return (0,_utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__["default"])(typeof padding !== 'number' ? padding : (0,_utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__["default"])(padding, _enums_js__WEBPACK_IMPORTED_MODULE_2__.basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(state.placement);
  var axis = (0,_utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__["default"])(basePlacement);
  var isVertical = [_enums_js__WEBPACK_IMPORTED_MODULE_2__.left, _enums_js__WEBPACK_IMPORTED_MODULE_2__.right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = (0,_dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__["default"])(arrowElement);
  var minProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__.top : _enums_js__WEBPACK_IMPORTED_MODULE_2__.left;
  var maxProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__.bottom : _enums_js__WEBPACK_IMPORTED_MODULE_2__.right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__["default"])(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_7__.within)(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!(0,_dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__["default"])(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js":
/*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   mapToStyles: () => (/* binding */ mapToStyles)
/* harmony export */ });
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js");
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../dom-utils/getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");
/* harmony import */ var _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../dom-utils/getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../dom-utils/getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js");
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js");
/* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js");
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js");







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(x * dpr) / dpr || 0,
    y: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__.left;
  var sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__.top;
  var win = window;

  if (adaptive) {
    var offsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__["default"])(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__["default"])(popper)) {
      offsetParent = (0,_dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__["default"])(popper);

      if ((0,_dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__["default"])(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.top || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.left || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.right) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__.end) {
      sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.left || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.top || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__.end) {
      sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__.right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__["default"])(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__["default"])(state.placement),
    variation: (0,_utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__["default"])(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../dom-utils/getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js");
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/flip.js":
/*!***********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/flip.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/getOppositePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js");
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js");
/* harmony import */ var _utils_getOppositeVariationPlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/getOppositeVariationPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js");
/* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js");
/* harmony import */ var _utils_computeAutoPlacement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/computeAutoPlacement.js */ "./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js");
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
/* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js");






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if ((0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(placement) === _enums_js__WEBPACK_IMPORTED_MODULE_1__.auto) {
    return [];
  }

  var oppositePlacement = (0,_utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(placement);
  return [(0,_utils_getOppositeVariationPlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(placement), oppositePlacement, (0,_utils_getOppositeVariationPlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [(0,_utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat((0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(placement) === _enums_js__WEBPACK_IMPORTED_MODULE_1__.auto ? (0,_utils_computeAutoPlacement_js__WEBPACK_IMPORTED_MODULE_4__["default"])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(placement);

    var isStartVariation = (0,_utils_getVariation_js__WEBPACK_IMPORTED_MODULE_5__["default"])(placement) === _enums_js__WEBPACK_IMPORTED_MODULE_1__.start;
    var isVertical = [_enums_js__WEBPACK_IMPORTED_MODULE_1__.top, _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_6__["default"])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? _enums_js__WEBPACK_IMPORTED_MODULE_1__.right : _enums_js__WEBPACK_IMPORTED_MODULE_1__.left : isStartVariation ? _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom : _enums_js__WEBPACK_IMPORTED_MODULE_1__.top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = (0,_utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(mainVariationSide);
    }

    var altVariationSide = (0,_utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/hide.js":
/*!***********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/hide.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
/* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js");



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [_enums_js__WEBPACK_IMPORTED_MODULE_0__.top, _enums_js__WEBPACK_IMPORTED_MODULE_0__.right, _enums_js__WEBPACK_IMPORTED_MODULE_0__.bottom, _enums_js__WEBPACK_IMPORTED_MODULE_0__.left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__["default"])(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__["default"])(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/index.js":
/*!************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/index.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   applyStyles: () => (/* reexport safe */ _applyStyles_js__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   arrow: () => (/* reexport safe */ _arrow_js__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   computeStyles: () => (/* reexport safe */ _computeStyles_js__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   eventListeners: () => (/* reexport safe */ _eventListeners_js__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   flip: () => (/* reexport safe */ _flip_js__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   hide: () => (/* reexport safe */ _hide_js__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   offset: () => (/* reexport safe */ _offset_js__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   popperOffsets: () => (/* reexport safe */ _popperOffsets_js__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   preventOverflow: () => (/* reexport safe */ _preventOverflow_js__WEBPACK_IMPORTED_MODULE_8__["default"])
/* harmony export */ });
/* harmony import */ var _applyStyles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./applyStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js");
/* harmony import */ var _arrow_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./arrow.js */ "./node_modules/@popperjs/core/lib/modifiers/arrow.js");
/* harmony import */ var _computeStyles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./computeStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js");
/* harmony import */ var _eventListeners_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./eventListeners.js */ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js");
/* harmony import */ var _flip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./flip.js */ "./node_modules/@popperjs/core/lib/modifiers/flip.js");
/* harmony import */ var _hide_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./hide.js */ "./node_modules/@popperjs/core/lib/modifiers/hide.js");
/* harmony import */ var _offset_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./offset.js */ "./node_modules/@popperjs/core/lib/modifiers/offset.js");
/* harmony import */ var _popperOffsets_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./popperOffsets.js */ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js");
/* harmony import */ var _preventOverflow_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./preventOverflow.js */ "./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js");










/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/offset.js":
/*!*************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/offset.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   distanceAndSkiddingToXY: () => (/* binding */ distanceAndSkiddingToXY)
/* harmony export */ });
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js");
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(placement);
  var invertDistance = [_enums_js__WEBPACK_IMPORTED_MODULE_1__.left, _enums_js__WEBPACK_IMPORTED_MODULE_1__.top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [_enums_js__WEBPACK_IMPORTED_MODULE_1__.left, _enums_js__WEBPACK_IMPORTED_MODULE_1__.right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = _enums_js__WEBPACK_IMPORTED_MODULE_1__.placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js":
/*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/computeOffsets.js */ "./node_modules/@popperjs/core/lib/utils/computeOffsets.js");


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = (0,_utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js");
/* harmony import */ var _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/getMainAxisFromPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js");
/* harmony import */ var _utils_getAltAxis_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/getAltAxis.js */ "./node_modules/@popperjs/core/lib/utils/getAltAxis.js");
/* harmony import */ var _utils_within_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../utils/within.js */ "./node_modules/@popperjs/core/lib/utils/within.js");
/* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../dom-utils/getLayoutRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js");
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js");
/* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js");
/* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js");
/* harmony import */ var _utils_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/getFreshSideObject.js */ "./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js");
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js");












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_1__["default"])(state.placement);
  var variation = (0,_utils_getVariation_js__WEBPACK_IMPORTED_MODULE_2__["default"])(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = (0,_utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(basePlacement);
  var altAxis = (0,_utils_getAltAxis_js__WEBPACK_IMPORTED_MODULE_4__["default"])(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.top : _enums_js__WEBPACK_IMPORTED_MODULE_5__.left;
    var altSide = mainAxis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.bottom : _enums_js__WEBPACK_IMPORTED_MODULE_5__.right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === _enums_js__WEBPACK_IMPORTED_MODULE_5__.start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === _enums_js__WEBPACK_IMPORTED_MODULE_5__.start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? (0,_dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_6__["default"])(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0,_utils_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_7__["default"])();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_8__.within)(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_9__["default"])(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_8__.within)(tether ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_10__.min)(min, tetherMin) : min, offset, tether ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_10__.max)(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.top : _enums_js__WEBPACK_IMPORTED_MODULE_5__.left;

    var _altSide = mainAxis === 'x' ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.bottom : _enums_js__WEBPACK_IMPORTED_MODULE_5__.right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [_enums_js__WEBPACK_IMPORTED_MODULE_5__.top, _enums_js__WEBPACK_IMPORTED_MODULE_5__.left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_8__.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_8__.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/popper-lite.js":
/*!********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/popper-lite.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createPopper: () => (/* binding */ createPopper),
/* harmony export */   defaultModifiers: () => (/* binding */ defaultModifiers),
/* harmony export */   detectOverflow: () => (/* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   popperGenerator: () => (/* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_4__.popperGenerator)
/* harmony export */ });
/* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/createPopper.js");
/* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js");
/* harmony import */ var _modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modifiers/eventListeners.js */ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js");
/* harmony import */ var _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modifiers/popperOffsets.js */ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js");
/* harmony import */ var _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modifiers/computeStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js");
/* harmony import */ var _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modifiers/applyStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js");





var defaultModifiers = [_modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__["default"], _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__["default"], _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__["default"], _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__["default"]];
var createPopper = /*#__PURE__*/(0,_createPopper_js__WEBPACK_IMPORTED_MODULE_4__.popperGenerator)({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ "./node_modules/@popperjs/core/lib/popper.js":
/*!***************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/popper.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   applyStyles: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.applyStyles),
/* harmony export */   arrow: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.arrow),
/* harmony export */   computeStyles: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.computeStyles),
/* harmony export */   createPopper: () => (/* binding */ createPopper),
/* harmony export */   createPopperLite: () => (/* reexport safe */ _popper_lite_js__WEBPACK_IMPORTED_MODULE_11__.createPopper),
/* harmony export */   defaultModifiers: () => (/* binding */ defaultModifiers),
/* harmony export */   detectOverflow: () => (/* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_10__["default"]),
/* harmony export */   eventListeners: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.eventListeners),
/* harmony export */   flip: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.flip),
/* harmony export */   hide: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.hide),
/* harmony export */   offset: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.offset),
/* harmony export */   popperGenerator: () => (/* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_9__.popperGenerator),
/* harmony export */   popperOffsets: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.popperOffsets),
/* harmony export */   preventOverflow: () => (/* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.preventOverflow)
/* harmony export */ });
/* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/createPopper.js");
/* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js");
/* harmony import */ var _modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modifiers/eventListeners.js */ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js");
/* harmony import */ var _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modifiers/popperOffsets.js */ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js");
/* harmony import */ var _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modifiers/computeStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js");
/* harmony import */ var _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modifiers/applyStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js");
/* harmony import */ var _modifiers_offset_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modifiers/offset.js */ "./node_modules/@popperjs/core/lib/modifiers/offset.js");
/* harmony import */ var _modifiers_flip_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modifiers/flip.js */ "./node_modules/@popperjs/core/lib/modifiers/flip.js");
/* harmony import */ var _modifiers_preventOverflow_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modifiers/preventOverflow.js */ "./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js");
/* harmony import */ var _modifiers_arrow_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modifiers/arrow.js */ "./node_modules/@popperjs/core/lib/modifiers/arrow.js");
/* harmony import */ var _modifiers_hide_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modifiers/hide.js */ "./node_modules/@popperjs/core/lib/modifiers/hide.js");
/* harmony import */ var _popper_lite_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./popper-lite.js */ "./node_modules/@popperjs/core/lib/popper-lite.js");
/* harmony import */ var _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modifiers/index.js */ "./node_modules/@popperjs/core/lib/modifiers/index.js");










var defaultModifiers = [_modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__["default"], _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__["default"], _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__["default"], _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__["default"], _modifiers_offset_js__WEBPACK_IMPORTED_MODULE_4__["default"], _modifiers_flip_js__WEBPACK_IMPORTED_MODULE_5__["default"], _modifiers_preventOverflow_js__WEBPACK_IMPORTED_MODULE_6__["default"], _modifiers_arrow_js__WEBPACK_IMPORTED_MODULE_7__["default"], _modifiers_hide_js__WEBPACK_IMPORTED_MODULE_8__["default"]];
var createPopper = /*#__PURE__*/(0,_createPopper_js__WEBPACK_IMPORTED_MODULE_9__.popperGenerator)({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ computeAutoPlacement)
/* harmony export */ });
/* harmony import */ var _getVariation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js");
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
/* harmony import */ var _detectOverflow_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js");
/* harmony import */ var _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js");




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.placements : _options$allowedAutoP;
  var variation = (0,_getVariation_js__WEBPACK_IMPORTED_MODULE_1__["default"])(placement);
  var placements = variation ? flipVariations ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.variationPlacements : _enums_js__WEBPACK_IMPORTED_MODULE_0__.variationPlacements.filter(function (placement) {
    return (0,_getVariation_js__WEBPACK_IMPORTED_MODULE_1__["default"])(placement) === variation;
  }) : _enums_js__WEBPACK_IMPORTED_MODULE_0__.basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = (0,_detectOverflow_js__WEBPACK_IMPORTED_MODULE_2__["default"])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[(0,_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/computeOffsets.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/computeOffsets.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ computeOffsets)
/* harmony export */ });
/* harmony import */ var _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js");
/* harmony import */ var _getVariation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js");
/* harmony import */ var _getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./getMainAxisFromPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js");
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? (0,_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(placement) : null;
  var variation = placement ? (0,_getVariation_js__WEBPACK_IMPORTED_MODULE_1__["default"])(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case _enums_js__WEBPACK_IMPORTED_MODULE_2__.top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__.bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__.right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__.left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? (0,_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case _enums_js__WEBPACK_IMPORTED_MODULE_2__.start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case _enums_js__WEBPACK_IMPORTED_MODULE_2__.end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/debounce.js":
/*!***********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/debounce.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ debounce)
/* harmony export */ });
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/detectOverflow.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ detectOverflow)
/* harmony export */ });
/* harmony import */ var _dom_utils_getClippingRect_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../dom-utils/getClippingRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js");
/* harmony import */ var _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../dom-utils/getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js");
/* harmony import */ var _dom_utils_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../dom-utils/getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js");
/* harmony import */ var _computeOffsets_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./computeOffsets.js */ "./node_modules/@popperjs/core/lib/utils/computeOffsets.js");
/* harmony import */ var _rectToClientRect_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./rectToClientRect.js */ "./node_modules/@popperjs/core/lib/utils/rectToClientRect.js");
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
/* harmony import */ var _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../dom-utils/instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js");
/* harmony import */ var _mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mergePaddingObject.js */ "./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js");
/* harmony import */ var _expandToHashMap_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./expandToHashMap.js */ "./node_modules/@popperjs/core/lib/utils/expandToHashMap.js");








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = (0,_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(typeof padding !== 'number' ? padding : (0,_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_2__["default"])(padding, _enums_js__WEBPACK_IMPORTED_MODULE_0__.basePlacements));
  var altContext = elementContext === _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.reference : _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = (0,_dom_utils_getClippingRect_js__WEBPACK_IMPORTED_MODULE_3__["default"])((0,_dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(element) ? element : element.contextElement || (0,_dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_5__["default"])(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = (0,_dom_utils_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_6__["default"])(state.elements.reference);
  var popperOffsets = (0,_computeOffsets_js__WEBPACK_IMPORTED_MODULE_7__["default"])({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = (0,_rectToClientRect_js__WEBPACK_IMPORTED_MODULE_8__["default"])(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [_enums_js__WEBPACK_IMPORTED_MODULE_0__.right, _enums_js__WEBPACK_IMPORTED_MODULE_0__.bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [_enums_js__WEBPACK_IMPORTED_MODULE_0__.top, _enums_js__WEBPACK_IMPORTED_MODULE_0__.bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/expandToHashMap.js":
/*!******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ expandToHashMap)
/* harmony export */ });
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/getAltAxis.js":
/*!*************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getAltAxis.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getAltAxis)
/* harmony export */ });
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getBasePlacement)
/* harmony export */ });

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getFreshSideObject)
/* harmony export */ });
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getMainAxisFromPlacement)
/* harmony export */ });
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getOppositePlacement)
/* harmony export */ });
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js":
/*!********************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getOppositeVariationPlacement)
/* harmony export */ });
var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/getVariation.js":
/*!***************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getVariation.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getVariation)
/* harmony export */ });
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/math.js":
/*!*******************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/math.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   max: () => (/* binding */ max),
/* harmony export */   min: () => (/* binding */ min),
/* harmony export */   round: () => (/* binding */ round)
/* harmony export */ });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/mergeByName.js":
/*!**************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/mergeByName.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ mergeByName)
/* harmony export */ });
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ mergePaddingObject)
/* harmony export */ });
/* harmony import */ var _getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getFreshSideObject.js */ "./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js");

function mergePaddingObject(paddingObject) {
  return Object.assign({}, (0,_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__["default"])(), paddingObject);
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/orderModifiers.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/orderModifiers.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ orderModifiers)
/* harmony export */ });
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js");
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return _enums_js__WEBPACK_IMPORTED_MODULE_0__.modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/rectToClientRect.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ rectToClientRect)
/* harmony export */ });
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/userAgent.js":
/*!************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/userAgent.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getUAString)
/* harmony export */ });
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

/***/ }),

/***/ "./node_modules/@popperjs/core/lib/utils/within.js":
/*!*********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/within.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   within: () => (/* binding */ within),
/* harmony export */   withinMaxClamp: () => (/* binding */ withinMaxClamp)
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./math.js */ "./node_modules/@popperjs/core/lib/utils/math.js");

function within(min, value, max) {
  return (0,_math_js__WEBPACK_IMPORTED_MODULE_0__.max)(min, (0,_math_js__WEBPACK_IMPORTED_MODULE_0__.min)(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),

/***/ "./node_modules/tippy.js/dist/tippy.esm.js":
/*!*************************************************!*\
  !*** ./node_modules/tippy.js/dist/tippy.esm.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   animateFill: () => (/* binding */ animateFill),
/* harmony export */   createSingleton: () => (/* binding */ createSingleton),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   delegate: () => (/* binding */ delegate),
/* harmony export */   followCursor: () => (/* binding */ followCursor),
/* harmony export */   hideAll: () => (/* binding */ hideAll),
/* harmony export */   inlinePositioning: () => (/* binding */ inlinePositioning),
/* harmony export */   roundArrow: () => (/* binding */ ROUND_ARROW),
/* harmony export */   sticky: () => (/* binding */ sticky)
/* harmony export */ });
/* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @popperjs/core */ "./node_modules/@popperjs/core/lib/popper.js");
/* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @popperjs/core */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js");
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/


var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (true) {
  resetVisitedMessages();
}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (true) {
    validateProps(partialProps, []);
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (true) {
      errorWhen(true, 'render() function has not been supplied.');
    }

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = (0,_popperjs_core__WEBPACK_IMPORTED_MODULE_0__.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (true) {
      // Accessibility check
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
    }
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (true) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (true) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
    } // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (true) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
    } // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (true) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
    }

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (true) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
    }

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (true) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (true) {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (true) {
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
  }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  mountedInstances.forEach(function (instance) {
    var isExcluded = false;

    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }

    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();

      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, _popperjs_core__WEBPACK_IMPORTED_MODULE_1__["default"], {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;

  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (true) {
    errorWhen(!Array.isArray(tippyInstances), ['The first argument passed to createSingleton() must be an array of', 'tippy instances. The passed value was', String(tippyInstances)].join(' '));
  }

  var individualInstances = tippyInstances;
  var references = [];
  var triggerTargets = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;

  function setTriggerTargets() {
    triggerTargets = individualInstances.map(function (instance) {
      return normalizeToArray(instance.props.triggerTarget || instance.reference);
    }).reduce(function (acc, item) {
      return acc.concat(item);
    }, []);
  }

  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }

  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }

  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;

      instance.setProps = function (props) {
        originalSetProps(props);

        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };

      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call


  function prepareInstance(singleton, target) {
    var index = triggerTargets.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }

    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        var _references$index;

        return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
      }
    }));
  }

  enableInstances(false);
  setReferences();
  setTriggerTargets();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: triggerTargets,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;

  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)


    if (currentTarget && target == null) {
      return;
    } // target is index of instance


    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance


    if (individualInstances.indexOf(target) >= 0) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement


    if (references.indexOf(target) >= 0) {
      return prepareInstance(singleton, target);
    }
  };

  singleton.showNext = function () {
    var first = references[0];

    if (!currentTarget) {
      return singleton.show(0);
    }

    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };

  singleton.showPrevious = function () {
    var last = references[references.length - 1];

    if (!currentTarget) {
      return singleton.show(last);
    }

    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };

  var originalSetProps = singleton.setProps;

  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };

  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    interceptSetPropsCleanups = interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: triggerTargets
    });
  };

  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};

var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (true) {
    errorWhen(!(props && props.target), ['You must specity a `target` prop indicating a CSS selector string matching', 'the target elements that should receive a tippy.'].join(' '));
  }

  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({
    touch: defaultProps.touch
  }, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);

  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }

    var targetNode = event.target.closest(target);

    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`


    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }

    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }

    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }

    var instance = tippy(targetNode, childProps);

    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }

  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }

  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }

  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;

    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }

      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }

      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };

    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };

    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };

    addEventListeners(instance);
  }

  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}

var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
      if (true) {
        errorWhen(instance.props.animateFill, 'The `animateFill` plugin requires the default render function.');
      }

      return {};
    }

    var _getChildren = getChildren(instance.popper),
        box = _getChildren.box,
        content = _getChildren.content;

    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}

var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];

function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}

function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}

function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}

var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;

    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }

    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }

    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }

    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }

    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
          clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;

      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;

            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }

            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }

    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }

    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });

      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }

    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;

        if (isInternalUpdate) {
          return;
        }

        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();

          if (followCursor) {
            create();

            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }

          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }

        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};

function getProps(props, modifier) {
  var _props$popperOptions;

  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}

var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;

    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }

    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var triedPlacements = [];
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (isEnabled()) {
          if (triedPlacements.indexOf(state.placement) !== -1) {
            triedPlacements = [];
          }

          if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
            triedPlacements.push(state.placement);
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }

          placement = state.placement;
        }
      }
    };

    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }

    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }

    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }

    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          var index = rects.indexOf(cursorRect);
          cursorRectIndex = index > -1 ? index : cursorRectIndex;
        }
      },
      onHidden: function onHidden() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined


  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }

  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }

    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;

        var _width = _right - _left;

        var _height = _bottom - _top;

        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }

    default:
      {
        return boundingRect;
      }
  }
}

var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
        popper = instance.popper;

    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }

    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }

    var prevRefRect = null;
    var prevPopRect = null;

    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }

      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};

function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }

  return true;
}

tippy.setDefaultProps({
  render: render
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (tippy);

//# sourceMappingURL=tippy.esm.js.map


/***/ }),

/***/ "./services/CartApi.ts":
/*!*****************************!*\
  !*** ./services/CartApi.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartApi)
/* harmony export */ });
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
class CartApi {
  /**
   *
   * @returns {Promise<any>}
   */
  static get() {
    var _this = this;
    return _asyncToGenerator(function* () {
      return yield _this.queryToCart('/cart.js');
    })();
  }
  /**
   *
   */
  static getItems() {
    return _asyncToGenerator(function* () {
      var _cart$items;
      var cart = yield CartApi.get();
      return (_cart$items = cart === null || cart === void 0 ? void 0 : cart.items) !== null && _cart$items !== void 0 ? _cart$items : [];
    })();
  }
  /**
   *
   * @param id
   * @param quantity
   * @param params
   */
  static addItem(id) {
    var _arguments = arguments;
    return _asyncToGenerator(function* () {
      var quantity = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 1;
      var params = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
      var items = [_objectSpread({
        id,
        quantity
      }, params !== null && params !== void 0 ? params : {})];
      return yield CartApi.addItems(items);
    })();
  }
  /**
   *
   * @param items
   */
  static addItems(items) {
    return _asyncToGenerator(function* () {
      return yield CartApi.queryToCart('/cart/add.js', {
        items: items
      }, 'POST');
    })();
  }
  /**
   *
   */
  static clearItems() {
    return _asyncToGenerator(function* () {
      return yield CartApi.queryToCart('/cart/clear.js', {}, 'POST');
    })();
  }
  /**
   *
   * @param id
   */
  static removeItem(id) {
    return _asyncToGenerator(function* () {
      return yield CartApi.queryToCart('/cart/change.js', {
        id: "".concat(id),
        quantity: 0
      }, 'POST');
    })();
  }
  /**
   *
   * @param beforeId
   * @param afterId
   * @param quantity
   */
  static replaceItem(beforeId, afterId) {
    var _arguments2 = arguments;
    return _asyncToGenerator(function* () {
      var _addResponse$items;
      var quantity = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : 1;
      var addResponse = yield CartApi.addItem(afterId, quantity);
      if (addResponse !== null && addResponse !== void 0 && (_addResponse$items = addResponse.items) !== null && _addResponse$items !== void 0 && _addResponse$items.length) yield CartApi.removeItem(beforeId);
      return addResponse;
    })();
  }
  /**
   *
   * @param key
   */
  static getAttribute(key) {
    return _asyncToGenerator(function* () {
      var _cart$attributes$key;
      var cart = yield CartApi.get();
      return key && !!(cart !== null && cart !== void 0 && cart.attributes) ? (_cart$attributes$key = cart.attributes[key]) !== null && _cart$attributes$key !== void 0 ? _cart$attributes$key : null : null;
    })();
  }
  /**
   *
   * @param attributes
   */
  static setAttribute(attributes) {
    return _asyncToGenerator(function* () {
      return yield CartApi.update({
        attributes
      });
    })();
  }
  /**
   *
   * @param params
   */
  static update(params) {
    return _asyncToGenerator(function* () {
      return yield CartApi.queryToCart('/cart/update.js', params, 'POST');
    })();
  }
  /**
   *
   * @param key
   */
  static removeAttribute(key) {
    return _asyncToGenerator(function* () {
      return yield CartApi.setAttribute({
        [key]: null
      });
    })();
  }
  /**
   *
   */
  static getLineItemsData() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var cartItems = yield _this2.getItems();
      return cartItems.map(item => ({
        price: item.price / 1000,
        product_id: item.product_id,
        variant_id: item.variant_id,
        properties: item.properties,
        quantity: item.quantity
      }));
    })();
  }
  /**
   *
   * @param url
   * @param body
   * @param method
   */
  static queryToCart(url) {
    var _arguments3 = arguments;
    return _asyncToGenerator(function* () {
      var body = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : null;
      var method = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : 'GET';
      var params = {
        method
      };
      if (method === 'POST') {
        params.headers = {
          'Content-Type': 'application/json'
        };
        params.body = JSON.stringify(body);
      }
      var response = yield fetch(url, params);
      return yield response.json();
    })();
  }
}

/***/ }),

/***/ "./utils.ts":
/*!******************!*\
  !*** ./utils.ts ***!
  \******************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deleteSearchParameter: () => (/* binding */ deleteSearchParameter),
/* harmony export */   hasSearchParameter: () => (/* binding */ hasSearchParameter),
/* harmony export */   setSearchParameter: () => (/* binding */ setSearchParameter),
/* harmony export */   toMoney: () => (/* binding */ toMoney),
/* harmony export */   toNumber: () => (/* binding */ toNumber),
/* harmony export */   waite: () => (/* binding */ waite)
/* harmony export */ });
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var toNumber = value => value.toLocaleString('en-US');
var toMoney = value => value.toLocaleString('en-US', {
  style: 'currency',
  currency: 'USD'
});
var setSearchParameter = (key, value) => {
  var url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState(null, '', url);
};
var deleteSearchParameter = key => {
  var url = new URL(window.location.href);
  url.searchParams.delete(key);
  window.history.replaceState(null, '', url);
};
var hasSearchParameter = key => {
  var url = new URL(window.location.href);
  return url.searchParams.has(key);
};
var waite = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
    return new Promise(resolve => setTimeout(resolve, time));
  });
  return function waite() {
    return _ref.apply(this, arguments);
  };
}();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*****************************!*\
  !*** ./components/index.ts ***!
  \*****************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Button */ "./components/Button.ts");
/* harmony import */ var _Wallpaper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Wallpaper */ "./components/Wallpaper.ts");
/* harmony import */ var _PackSelector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PackSelector */ "./components/PackSelector.ts");
/* harmony import */ var _PackSelectorMembersOnly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PackSelectorMembersOnly */ "./components/PackSelectorMembersOnly.ts");
/* harmony import */ var _PackSelectorNewDesign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PackSelectorNewDesign */ "./components/PackSelectorNewDesign.ts");
/* harmony import */ var _PackSelectorOption__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./PackSelectorOption */ "./components/PackSelectorOption.ts");
/* harmony import */ var _PackSelectorOptionNewDesign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./PackSelectorOptionNewDesign */ "./components/PackSelectorOptionNewDesign.ts");
/* harmony import */ var _PackSelectorV2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./PackSelectorV2 */ "./components/PackSelectorV2.ts");
/* harmony import */ var _PackSelectorOptionV2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./PackSelectorOptionV2 */ "./components/PackSelectorOptionV2.ts");
/* harmony import */ var _StoreCountdown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StoreCountdown */ "./components/StoreCountdown.ts");
/* harmony import */ var _SparkleStars__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./SparkleStars */ "./components/SparkleStars.ts");
/* harmony import */ var _SimplePackSelector__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./SimplePackSelector */ "./components/SimplePackSelector.ts");
/* harmony import */ var _SimplePackSelectorOption__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./SimplePackSelectorOption */ "./components/SimplePackSelectorOption.ts");
/* harmony import */ var _PackSelectorOptionMembersOnly__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./PackSelectorOptionMembersOnly */ "./components/PackSelectorOptionMembersOnly.ts");
/* harmony import */ var _SimplePackSelectorNewDesign__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./SimplePackSelectorNewDesign */ "./components/SimplePackSelectorNewDesign.ts");
/* harmony import */ var _SimplePackSelectorOptionNewDesign__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./SimplePackSelectorOptionNewDesign */ "./components/SimplePackSelectorOptionNewDesign.ts");
/* harmony import */ var _PackSelectorOptionNewDesignV2__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./PackSelectorOptionNewDesignV2 */ "./components/PackSelectorOptionNewDesignV2.ts");

















if (!customElements.get('rl-button')) customElements.define('rl-button', _Button__WEBPACK_IMPORTED_MODULE_0__.Button);
if (!customElements.get('rl-wallpaper')) customElements.define('rl-wallpaper', _Wallpaper__WEBPACK_IMPORTED_MODULE_1__.Wallpaper);
if (!customElements.get('rl-simple-pack-selector')) customElements.define('rl-simple-pack-selector', _SimplePackSelector__WEBPACK_IMPORTED_MODULE_11__.SimplePackSelector);
if (!customElements.get('rl-simple-pack-selector-new')) customElements.define('rl-simple-pack-selector-new', _SimplePackSelectorNewDesign__WEBPACK_IMPORTED_MODULE_14__.SimplePackSelectorNewDesign);
if (!customElements.get('rl-simple-pack-selector-option')) customElements.define('rl-simple-pack-selector-option', _SimplePackSelectorOption__WEBPACK_IMPORTED_MODULE_12__.SimplePackSelectorOption);
if (!customElements.get('rl-simple-pack-selector-option-new')) customElements.define('rl-simple-pack-selector-option-new', _SimplePackSelectorOptionNewDesign__WEBPACK_IMPORTED_MODULE_15__.SimplePackSelectorOptionNewDesign);
if (!customElements.get('rl-pack-selector')) customElements.define('rl-pack-selector', _PackSelector__WEBPACK_IMPORTED_MODULE_2__.PackSelector);
if (!customElements.get('rl-pack-selector-new')) customElements.define('rl-pack-selector-new', _PackSelectorNewDesign__WEBPACK_IMPORTED_MODULE_4__.PackSelectorNewDesign);
if (!customElements.get('rl-pack-selector-option')) customElements.define('rl-pack-selector-option', _PackSelectorOption__WEBPACK_IMPORTED_MODULE_5__.PackSelectorOption);
if (!customElements.get('rl-pack-selector-option-new')) customElements.define('rl-pack-selector-option-new', _PackSelectorOptionNewDesign__WEBPACK_IMPORTED_MODULE_6__.PackSelectorOptionNewDesign);
if (!customElements.get('rl-pack-selector-option-new-v2')) customElements.define('rl-pack-selector-option-new-v2', _PackSelectorOptionNewDesignV2__WEBPACK_IMPORTED_MODULE_16__.PackSelectorOptionNewDesignV2);
if (!customElements.get('rl-pack-membersonly-selector')) customElements.define('rl-pack-membersonly-selector', _PackSelectorMembersOnly__WEBPACK_IMPORTED_MODULE_3__.PackSelectorMembersOnly);
if (!customElements.get('rl-pack-selector-members-only-option')) customElements.define('rl-pack-selector-members-only-option', _PackSelectorOptionMembersOnly__WEBPACK_IMPORTED_MODULE_13__.PackSelectorOptionMembersOnly);
if (!customElements.get('rl-perk')) customElements.define('rl-perk', _PackSelectorOption__WEBPACK_IMPORTED_MODULE_5__.Perk);
if (!customElements.get('rl-perk-new')) customElements.define('rl-perk-new', _PackSelectorOptionNewDesign__WEBPACK_IMPORTED_MODULE_6__.PerkNewDesign);
if (!customElements.get('rl-pack-selector-v-2')) customElements.define('rl-pack-selector-v-2', _PackSelectorV2__WEBPACK_IMPORTED_MODULE_7__.PackSelectorV2);
if (!customElements.get('rl-pack-selector-option-v-2')) customElements.define('rl-pack-selector-option-v-2', _PackSelectorOptionV2__WEBPACK_IMPORTED_MODULE_8__.PackSelectorOptionV2);
if (!customElements.get('rl-countdown')) customElements.define('rl-countdown', _StoreCountdown__WEBPACK_IMPORTED_MODULE_9__.StoreCountdown);
if (!customElements.get('rl-sparkle-stars')) customElements.define('rl-sparkle-stars', _SparkleStars__WEBPACK_IMPORTED_MODULE_10__.SparkleStars);
})();

/******/ })()
;